/**
* @fileoverview Здесь будут лежать разные настрйоки по умолчанию и изменения относительно существующих jquery плагинов
* @requires qform.js
*/

	// Некоторые события
	$(document).ready(function()
	{
		// Зададим выделение строчек по CTRL-A
		// When ctrl+a is typed on the keyboard select all the rows in the table (the table has to have focus)
		$(document).keydown
		(
			function(event)
			{
				if ((event.ctrlKey || event.altKey || event.metaKey) && (event.which === 65)) //'A'
				{
					if(!$(event.target).is("input,textarea") && !$(event.target).closest('div.redactor-editor').length)
					{
						//alert(event.which);
						event.preventDefault();

						// Для начала найдем походящую нам таблицу
						var $tbl = $("#mainContainer table.qlist-table.dataTable, div.tab-content > div.tab-pane.active table.qlist-table.dataTable").last();
						////console.log(oThisQ.$.MainTbl.html());
						var oThisQ = $tbl.data("q-data-table");
						oThisQ.fnToggleRowSelection($tbl.find("tbody tr.odd, tbody tr.even"), true);
						oThisQ.fnUpdateSelection();

						//that.fnSetButtonState(that);
					}
				}
			}
		);

		//меняем z-index у открытого фильтра dropdown,чтобы при скролле
		//панель не была поверх других элементов
		if(document.querySelector('.qlist-container  .q-filter .q-dropdown')) {
			window.addEventListener('scroll', function() {
				const qPageHeaderNode = document.querySelector('.qlist-container .qlist-page-header');
				const openedFilterNode = document.querySelector('.qlist-body .filters-panel .q-filter .q-dropdown.dropdown-open');
				if(!openedFilterNode)
					return false;
				const openedFilterInputNode = openedFilterNode.querySelector('input');
				const openedFilterId = openedFilterNode.dataset.dropdown;
				const openedDropdownPanel = document.querySelector(openedFilterId);
				if(!openedDropdownPanel)
					return false;
				const DOMRectOpenedDropdownPanel = openedDropdownPanel.getBoundingClientRect();
				const DOMRectQPageHeaderNode = qPageHeaderNode.getBoundingClientRect();
				const DOMRectFilterInputNode = openedFilterInputNode.getBoundingClientRect();
				if(DOMRectFilterInputNode.top > DOMRectOpenedDropdownPanel.top) {
					if(DOMRectOpenedDropdownPanel.top + DOMRectOpenedDropdownPanel.height < DOMRectQPageHeaderNode.top + DOMRectQPageHeaderNode.height) {
						openedFilterNode.parentNode.style.zIndex = 0;
						openedDropdownPanel.style.zIndex = 1;
					}
					else {
						openedFilterNode.parentNode.style.zIndex = 'auto';
						openedDropdownPanel.style.zIndex = 11049;
					}
				}
				else {
					if(DOMRectFilterInputNode.top < DOMRectQPageHeaderNode.top + DOMRectQPageHeaderNode.height) {
						openedFilterNode.parentNode.style.zIndex = 0;
						openedDropdownPanel.style.zIndex = 1;
					}
					else {
						openedFilterNode.parentNode.style.zIndex = 'auto';
						openedDropdownPanel.style.zIndex = 11049;
					}
				}
			});
		}

		//крайний фильтр не будет вылезать за пределы экрана
		document.querySelectorAll('.qlist-body .filters-panel .q-filter .q-dropdown').forEach((elem) => elem.addEventListener('click', (event) => {
			const dropdownListId = event.currentTarget.dataset.dropdown;
			setTimeout(() => {
				const qListContainerWidth = document.querySelector('.qlist-container').getBoundingClientRect().width;
				const dropdownListNode = document.querySelector(dropdownListId);
				if(Number(dropdownListNode.style.left.replace('px', '')) + Number(dropdownListNode.style.minWidth.replace('px', '')) >= qListContainerWidth)
					dropdownListNode.style.minWidth = 'min-content';
			}, 0);
		}))
		//
		// console.log($("[name='filter_f_did']").children());
		// console.log(localStorage.getItem('ls_' + '{{preserve_name_department}}'));
		// $("[name='filter_f_did']").val('3002').change();
	});



	/**
	 * Создает объект для работы с таблицей-списком.
	 *
	 * @class Основной класс для работы с dataTables.
	 * @constructor
	 * @param {string|jQuery|DOM} mSelector jQuery-селектор объекта, в котором надо создать таблицу-список.
	 * @param {object} oTableOptions Параметры которые следует передать в jQuery.dataTable().
	 * @param {object} aOptions Прочие дополнительные параметры. Опишу позднее. @todo Описать aOptions
	 * @param {number} [iType=DATA_TABLE_TYPEFULL] Тип таблицы. Может принимать значения DATA_TABLE_FULL | DATA_TABLE_MINI | DATA_TABLE_CUSTOM.
	 * @returns {void}
	 *
	 * @author Igor Kuzmin <random@academic.ru>
	 */
	Q.DATA_TABLE = function(mSelector, oTableOptions, iType, aOptions)
	{
		/** {string|jQuery|DOM} jQuery-селектор для обращения к плагину jquery.dataTables(). */
		this.mSelector = mSelector;
		/** {object} Cсылка на объект dataTables */
		this.oTable = {};
		/** {array} Массив с идентификаторами выбранных строк. */
		this.aSelectedIds = [];

		this.oAccessMarkers = {};

		this.aOptions = {}; // Далее они будут заполнены
		this.iType = iType;

		this.ooData = {}; // объект с переданной через AJAX информацией.


		var defaultOptions =
		{
			"bFramed":false,
			"sFrameAs":"",

			"iRowsPerPage":50,
			"bInfiniteScroll": 0,

			"iListWidth":0,
			"iListHeight":0,

			"bHasTabs":0,

			"bResponsive": 0,

			"bHideNewRec":0,
			"bHideEditBtn": 0,
			"bHideViewBtn": 1,
			"bHideDelBtn": 0,
			"bHideButtons":0,
			"bHasReports":0,
			"bMultiEdit": 0,

            "bHasRss": 0,
            "aaUserTokens":[],

			"aReportsParams":[],

			"iFormWidth":0, // means "auto"
			"iFormHeight":0, // means "auto"
			"sFormTitle":"",
			"sReportsUrl":"",
			"sChartsUrl":"",
			"sCalendarUrl": "",
			"sImportUpload": "",
			"sCsvExportUrl":"",
			"sExcelExportUrl":"",
			"sFilesUrl":"", // Скорее всего, на момент прочтения вам этих строк, уже НЕ используется.

			"sReportsButtonCaption": "Отчёты",

			"aExternVars":[],

			"sDeleteUrl":"",

			"sEntity":"",
            "sAction":"",
			"sParentEntity":"",

			"sDomIdPrefix":"",

			"iAccessRead":0,
			"iAccessEdit":0,
			"iAccessDelete":0,
			"iAccessAdd":0,

			"bDblClickForm": 1
		};

		$.extend ( this.aOptions, defaultOptions, aOptions);

		this.sDomId = $(this.mSelector).attr("id");

		/**
		 * @namesapce Здесь находятся ссылки на jQuery объекты
		 * разных элементов списка, для быстрого доступа
		 */
		this.$ = {bInitted:0};
		this.$.MainTbl = $(this.mSelector);

		this.fnSetStickyHeader();

		this.$.MainTbl.closest(".form-material").removeClass("form-material"); // убираем класс MD, т.к. он портит внешний вид.
		this.init(oTableOptions);

	};

	/**
	 * Инициализирует dataTables — запускает соответвующие jQuery-методы, добавляет сайдбар и пр.
	 */
	Q.DATA_TABLE.prototype.init = function(/** {object} */ oTableOptions)
	{
		var oThisQ = this;
		var that = this;
		var oTableOptions2Use = {};
		// В зависимости от типа таблицы, натянем заранее готовый шаблон и применим к нему свойства, переданные в конструкторе (именно в таком порядке — у переданных св-в приоритет д/б выше)
		switch(this.iType)
		{
			case DATA_TABLE_TYPEFULL:
				$.extend ( oTableOptions2Use, Q.dataTables.oDefaultTableOptions, oTableOptions);
				break;
			case DATA_TABLE_MINI:
				$.extend ( oTableOptions2Use, Q.dataTables.oDefaultSmallTableOptions, oTableOptions);
				break;
			case DATA_TABLE_CUSTOM:
			default:
				//oTableOptions2Use = oTableOptions;
				break;
		}

		this.aGrNodesOpened = []; // тут будут храниться открытые ветки групп.

		this.$.DataCol = this.$.MainTbl; // для совместимости. Хотя, наверное, уже и так нигде не используется
		//alert(this.aOptions.sDomIdPrefix);
		this.$.MainPanel = $("#"+this.aOptions.sDomIdPrefix+"MainPanel");
		this.$.SidePanel = $("#"+this.aOptions.sDomIdPrefix+"SidePanel");
		this.$.ButtonsPanel = $("#"+this.aOptions.sDomIdPrefix+"ButtonsPanel");

		this.$.btnAdd = $("#"+this.aOptions.sDomIdPrefix+"AddBtn")
			.unbind('click')
			.click(function()
			{
				//alert(oThisQ.fnGetSelected());
				var $btn = $(this).data("loading-text","Загружаю…").buttonStartLoading();
				oThisQ.fnOpenForm(0, function()
				{
					//console.log("fnOnOpen");
					$btn.buttonStopLoading();
				});

				return false;
			})
			.tooltip();

		this.$.btnDubl = $("#"+this.aOptions.sDomIdPrefix+"DublBtn")
			.unbind('click')
			.click(function()
			{
				var aSelected = oThisQ.fnGetSelected();
				var id = aSelected[0];

				if(aSelected.length > 1) var mId = aSelected;
				else var mId = id;

				var $btn = $(this).data("loading-text","Загружаю…").buttonStartLoading();

				oThisQ.fnOpenForm(mId, function()
				{
					$btn.buttonStopLoading();

				}, "dublicate");

				return false;
			});

		this.$.btnAdd.attr("disabled", "0").removeAttr("disabled");

		this.$.btnEdit = $("#"+this.aOptions.sDomIdPrefix+"EditBtn")
			.unbind('click')
			.click(function()
			{
				var aSelected = oThisQ.fnGetSelected();
				var id = aSelected[0];

				if(aSelected.length > 1) var mId = aSelected;
				else var mId = id;

				var $btn = $(this).data("loading-text","Загружаю…").buttonStartLoading();

				oThisQ.fnOpenForm(mId, function()
				{
					$btn.buttonStopLoading();
				});

				return false;
			});

		this.$.btnView = $("#"+this.aOptions.sDomIdPrefix+"ViewBtn")
			.unbind('click')
			.click(function()
			{
				var aSelected = oThisQ.fnGetSelected();
				var id = aSelected[0];
				var $btn = $(this).data("loading-text","Загружаю…").buttonStartLoading();

				oThisQ.fnOpenView(id, function()
				{
					$btn.buttonStopLoading();
				});

				return false;
			});

		this.$.btnDelete = $("#"+this.aOptions.sDomIdPrefix+"DeleteBtn")
			.unbind('click')
			.click(function()
			{
				var aSelected = oThisQ.fnGetSelected();

				//alert("!!!");

				Q.fnConfirm( "Записей к удалению: "+aSelected.length+".<br />"
							+"Вы действительно хотите удалить?",
							function($btn, $Modal)
							{
								$btn.data("loading-text","Удаляю…").buttonStartLoading();
								oThisQ.fnDeleteEntries(aSelected, function()
								{
									$btn.buttonStopLoading();
									$Modal.modal('hide');
								});
								//alert(aSelected);
								return false;
							},
							"Удалить ("+aSelected.length+")", "warning");

				return false;
			});

		// Сделаем так, чтобы по нажатию на SHIFT показывалась кнопка «дублировать»
		$(window).on('keydown.'+this.aOptions.sDomIdPrefix,

			function(event)
			{
				if ((event.shiftKey))
				{
					// Проверим, нет ли объектов над нашим…
					if(! that.$.btnAdd.closest(".modal-wrapper, #mainContainer").nextAll(".modal-wrapper").length)
					{
						if(!(that.$.btnDubl.data('hidedbl')))
						{
							that.$.btnAdd.hide();
							that.$.btnDubl.show();
						}
					}
				}
			}
		);
		$(window).on('focus.'+this.aOptions.sDomIdPrefix
		          +  ' blur.'+this.aOptions.sDomIdPrefix
		          + ' keyup.'+this.aOptions.sDomIdPrefix,

			function(event)
			{
				if (event.type != "keyup" || !event.shiftKey)
				{
					if(!(that.$.btnDubl.data('hidedbl')))
					{
						that.$.btnAdd.show();
						that.$.btnDubl.hide();
					}
				}
			}
		);

		this.$.MainPanel.onFirst('destroyed', function(){ $(window).off("."+that.aOptions.sDomIdPrefix); console.log("events disabled"); } );

		this.$.ButtonsPanel
			.find("button.mybtn")
			/**
				.each(function()
				{
					var bSelectionOnly = $(this).data("selectiononly");
					var cntIds = oThisQ.fnGetSelected().length;
					var bDisable;
					if(!bSelectionOnly) bDisable = true;
					else
					{
						if(bSelectionOnly == 1 && cntIds == 1) bDisable = true;
						else if(bSelectionOnly == 2 && cntIds >= 1)  bDisable = true;
						else bDisable = false;
					}
					if( bDisable )
					{
						$(this)
							.attr("disabled", "0")
							.removeAttr("disabled");
					}
				}) ***/
				.click(function()
				{
					var $this = $(this);
					var jsOnClick;
					var sModule;
					var sHref;
					if(jsOnClick = $this.data("onclick"))
					{
						var ids = oThisQ.fnGetSelected();
						var rows = that.ooData;

						if(ids.length && jsOnClick.split('{{row.').length > 1) {
							jsOnClick = jsOnClick.replace(/\{\{row.([^\}]*)\}\}/gi, function(str, sCol)
							{
							 if(isset(rows[ids[0]][sCol]))
							  return rows[ids[0]][sCol];
							 else
							  return 'null';
							});
						   }

						(function()
						{

							eval(jsOnClick);
						})();
					}
					else if(sModule = $this.data("module"))
					{
						var ids = oThisQ.fnGetSelected();
						////console.dir($this.data("params"));
						var aParams;
						if(empty($this.data("params"))) aParams = {};
						else aParams = new cloneObject($this.data("params"));

						if(that.ooData[ids[0]])
						if(that.ooData[ids[0]].raw)
						{
							var s, i, till, sParam, sKey, sParam1, sKey1, aRaws = {};
							for(i=0,till=ids.length; i<till; i++)
							{
								for(s in that.ooData[ids[i]].raw)
								{
									if(aRaws[s] === undefined) aRaws[s] = [];
									aRaws[s][i] = that.ooData[ids[i]].raw[s];
								}
							}

							for(s in aParams)
							{
								if(aParams[s] instanceof Array)
								{
									sKey = aParams[s][0];
									sParam = aParams[s][1];

									if(sParam.split('{{row.').length > 1)
									{
										if(sKey !== null) aParams[s] = {};
										else aParams[s] = [];
										for(i=0,till=ids.length; i<till; i++)
										{
											if(sKey !== null)
											{
												sKey1 = sKey.replace(/\{\{row.([^\}]*)\}\}/gi, function(str, sCol)
													{
														return aRaws[sCol][i];
													});
											}

											sParam1 = sParam.replace(/\{\{row.([^\}]*)\}\}/gi, function(str, sCol)
												{
													return aRaws[sCol][i];
												});

											if(sKey !== null) aParams[s][sKey1] = sParam1;
											else aParams[s][i] = sParam1;

										}
									}


								}
								else
								{
									sParam = aParams[s];

									if(sParam.split('{{row.').length > 1)
									{
										aParams[s] = '';
										var sVal = null;
										var sOldVal = null;
										for(i=0,till=ids.length; i<till; i++)
										{
											sVal = sParam.replace(/\{\{row.([^\}]*)\}\}/gi, function(str, sCol)
											{
												return aRaws[sCol][i];
											});
											if(sOldVal === null) sOldVal = sVal;

											if(sVal !== sOldVal)
											{
												sVal = ":null:";
												break;
											}
										}
										aParams[s] = sVal;
									}
								}
							}
						}

						//console.log("aRaws: %o", aRaws);
						//console.log("aParams: %o", aParams);

						var oOtherPostVars = {};
						if($this.data("sendfilters"))
						{
							oOtherPostVars.filters = {};

							// #FIXME @todo DRY!!!!
							$("#"+oThisQ.aOptions.sDomIdPrefix+"Filters").find("div.q-filter").each(function()
							{
								var $filter = $(this);
								$filter.find("input, select, textarea").each(function()
								{
							        if(this.name) // только те, у которых есть имя =)
						        	{
						        		var $this = $(this);
						        		if(this.type=="checkbox" || this.type=="radio") if(!$this.is(":checked")) return;
						        		var sVal = $this.val();
						        		var sName = this.name.split(/^filter_/).join("");
						        		oOtherPostVars.filters[sName] = sVal;
						        	}
							    });
							});
						}

						if($this.data("sendrow") && ids.length)
						{
							oOtherPostVars.row = {};
							//console.log(ids.length);
							for(var i=0; i<ids.length; i++)
							{
								var id = ids[i];
								//console.log("atatata: "+i);
								if(!i)
								{
									oOtherPostVars.row = new cloneObject(that.ooData[id]);
								}
								else
								{
									for( sKey in that.ooData[id] )
									{
										//console.log("sKey="+sKey+";  oOtherPostVars.row[sKey]="+oOtherPostVars.row[sKey]+"; that.ooData[id][sKey]="+that.ooData[id][sKey]);
										if(oOtherPostVars.row[sKey] != that.ooData[id][sKey])
											oOtherPostVars.row[sKey] = ':null:';
									}
								}
							}
						}

						var oSetFields = $this.data("setfields");

						//console.dir(oSetFields); console.log($.type(oSetFields)); return false;

						if(empty(oSetFields))
						{
							//alert($this.data("editmode"));
							if(Number($this.data("editmode")))
							{
								//alert("!!");
								// if(typeof(ids[0])!=='undefined') var id = ids[0];
								// else id = 0;
								// aParams.ids = ids;
								// aParams.id = ids[0];
								if(ids.length == 1) var ids2send = ids[0];
								else var ids2send = ids;
							}
							else
							{

								aParams.external_ids = ids.join(","); // для совместимости со старыми версиями…
								aParams.selected_ids = ids;
								if(empty(ids)) aParams.selected_ids = [];
								if(typeof(ids[0])!=='undefined') var id = ids[0];
								else id = 0;
								aParams.external_id = id; // для совместимости со старыми версиями…
								aParams.selected_id = id;

								var ids2send = 0;

							}

							switch($this.data("action"))
							{
								case "form":
									QForm.fnOpenForm(sModule, ids2send , aParams, null, null, oThisQ.aOptions.sParentEntity, oOtherPostVars);
									break;
								case "list":
									QForm.openExternalSelectDialog(null, "/q/"+sModule, $this.data("title"), aParams, oOtherPostVars); // , sTitle // _TODO: Параметры пока не поддерживаются
									break;
								default:
									QForm.fnAlertError("Ошибка! Недопустимое действие (@action). Пожалуйста, напишите в техническую поддержку.");
									break;
							}

						}
						else
						{
							var aDataToSend = $.extend({}, oSetFields);
							aDataToSend.externvar = aParams;
							aDataToSend.ids = ids;
							aDataToSend.multiple = 1;

							$.ajax(
							{
								url:"/"+Q.WORKSPACE+"/q/"+sModule+"/store",
								data: aDataToSend,
								type: "POST",
								success: function(sTxt)
								{
									//console.log(sTxt);
									// oThisQ.oTable.fnAdjustColumnSizing(true);
									oThisQ.fnAutoSize();
								}

							});
						}
					}
					else if(sHref = $this.data("url"))
					{
						var sTarget = $this.data("url");
						if(sTarget=='')
						{
							document.location.href=sHref;
						}
						else
						{
							window.open(sHref,sTarget);
						}
					}
					if(!empty($this.data("hasevents")))
					{
						var ids = oThisQ.fnGetSelected();
//						console.log("that : %o", that);
						$.ajax
						({
							type: "GET", // для уменьшения нагрузки шлем гетом. (POST обменивается еще и хедерами)
							dataType: "json",
							url: that.aOptions.sAjaxSource,
							data: {"act":"button", "button":$this.data('buttonname'), "id[]":ids, "external": aParams},
							beforeSend: function()
							{
								//Q.fnShowLoader("Подождите, идёт удаление…");
								$this.data("loading-text","Выполняю…").buttonStartLoading();
							},
							complete: function()
							{
								//Q.fnCloseLoader();
								$this.buttonStopLoading();
							},
							success: function(jsonobj, textStatus, jqXHR)
							{
								if(jsonobj.success)
								{
									oThisQ.fnAutoSize();
								}
								else
								{
									var code = (typeof(jsonobj.success) !== "undefined")?1:2;
									Q.fnAlertError("<h2>Неизвестная ошибка (код: "+code+")</h2><p><b>Запрашиваемая операция не может быть выполнена.</b><br>Пожалуйста, обратитесь в службу технической поддержки.</p>");
								}
							},
							error: function()
							{
								Q.fnAlertError("<h2>Неизвестная ошибка (код: "+2+")</h2><p><b>Запрашиваемая операция не может быть выполнена.</b><br>Пожалуйста, обратитесь в службу технической поддержки.</p>");
							}
							/**
							,
							failed: function()
							{
								//console.log("deleting failed");
								Q.fnAlertError("Проверьте подключение к Интернет");
							}
							**/
						});
					}

					return false; // Обязательно, чтобы не вызывали сохранение формы во встроенных списках.

				});

		/****
		this.$.btnRefresh = $("#"+this.aOptions.sDomIdPrefix+"RefreshBtn")
			.unbind('click')
			.click(function()
			{
				// oThisQ.oTable.fnAdjustColumnSizing(true); // true — чтобы обновить!!

				return false;
			});
		/*****/

		if(this.aOptions.bFramed)
		{
			var size = this.getNewSize();

			oTableOptions2Use.sScrollX = "100%";
			oTableOptions2Use.sScrollY = size.h+"px";
		};

		/*
		 * Инициализация DATATABLES
		 */
		$(this.mSelector).data("q-data-table", this);
		///this.ttttt = 1;

		//console.log("oTableOptions2Use=");
		//console.dir(oTableOptions2Use);
		this.oTable = $(this.mSelector).DataTable(oTableOptions2Use);

		this.$.DataTable_wrapper = this.$.MainTbl.parents("div.dataTables_wrapper");

		this.$.DataTables_scrollHead = this.$.DataTable_wrapper.find("div.dataTables_scrollHead");
		this.$.DataTables_scrollBody = this.$.DataTable_wrapper.find("div.dataTables_scrollBody");

		this.$.bInitted = 1;

		// Инициализируем правую панель
		this.fnInitSidePanel();
	};

	Q.DATA_TABLE.prototype.fnInitSidePanel = function ( )
	{
		var that = this;

		// Инициализируем все схлопывающиеся элементы
		// this.$.SidePanel.find("div.qui-toggleable").toggleable();

		// Далее пойдут функции скролла. Их надо тестировать и они пока нам не нужны. Но оставлю здесь.
		/**
		this.$.SidePanelScrollable = this.$.SidePanel.find("div.sidePanelScrollable");//.height(220);

		var oOffset =  this.$.SidePanelScrollable.offset();

		var iPaddings = this.$.SidePanelScrollable.outerHeight() - this.$.SidePanelScrollable.height();
		if(!$(this.aOptions.sFrameAs).is(".EmbededList")) // @todo быдлокодинг.
		{
			var iHeightWindow = $(window).height();
		}
		else
		{
			var iHeightWindow = $(this.aOptions.sFrameAs).height();
		}
		var iHeightNew = iHeightWindow - oOffset.top - iPaddings;// - 12;
		if($(this.aOptions.sFrameAs).is(".EmbededList")) iHeightNew += $(this.aOptions.sFrameAs).offset().top;
		this.$.SidePanelScrollable.height(iHeightNew);

		// Инициализируем скролл
		//alert($(this.aOptions.sFrameAs).is(".EmbededList"));
		//if(!$(this.aOptions.sFrameAs).is(".EmbededList"))
		{
			this.$.SidePanelScrollable.addClass("scrollified");
			//this.$.SidePanelScrollable.wrapInner('<div class="viewport absolute"><div class="overview"></div></div>');// для начала создадим viewport
			//this.$.SidePanelScrollable.prepend('<div class="scrollbar"><div class="track"><div class="thumb"><div class="end"></div></div></div></div>');// и скролл
			// подготовка завершена, вызываем плагин:
			this.$.SidePanelScrollable.tinyscrollbar();

			this.$.SidePanelScrollable.resize(function()
			{
				//console.log("scrollbar resized");
				$(this).tinyscrollbar_update("relative");
			});
		};

		this.$.SidePanelScrollable.on('click', $.proxy(function()
		{
			this.$.SidePanelScrollable.tinyscrollbar_update("relative");
		},this));

		/**/ // TODO: доработать скроллбар

		// Инициализируем фильтры
		this.fnInitFilters();
		// Загрушка под Базу Знаний. А то мало ли что.
		this.fnInitKnowledgeLinks();
	};

	Q.DATA_TABLE.prototype.fnUpdateFiltersCount = function()
	{
		var htmlCount = "";
		var htmlCountAndText = "";
		var nTotalCount = this.$.formFilters.find(".q-filter").not(".all-hidden").length;
		var nSettedCount = this.$.formFilters.find(".q-filter.setted").not(".all-hidden").length;

		if(nSettedCount)
		{
			htmlCount = '<em>%d</em> из '+nTotalCount+'';
			htmlCountAndText =
				"Фильтры <span class=\"filters-counts\">("
				+	get_correct_str(nSettedCount
				                  , htmlCount+" выбран"
				                  , htmlCount+" выбрано"
				                  , htmlCount+" выбрано")
				+	")</span>";
		}
		else
		{
			htmlCount = nTotalCount;
			htmlCountAndText = "Фильтры <span class=\"filters-counts\">("+nTotalCount+")</span>";
		}

		this.$.filtersPanel.toggleClass("all-filters-selected", (nSettedCount == nTotalCount));
		this.$.filtersPanel.toggleClass("no-filters-selected", (nSettedCount == 0));

		// if(this.bFramed) {
		this.$.filtersPanel.find(".btnMoreFilters").html(htmlCountAndText);
		// }

	}

	Q.DATA_TABLE.prototype.fnIsFilterDefault = function($filter)
	{
		var $this;
		var bResult = true;

		$filter.find("input:checkbox, input:radio").each(function()
		{
			$this = $(this);
			if($this.data('is-preference')) return true;
			if($this.closest(".controls.hidden-filter").length) return true;
			var bChecked = $this.data("default-checked");
			// console.log($this.attr("id")," --- ",$this.is(":checked")," vs ", bChecked);
			if( $this.is(":checked") !== bChecked ) { bResult = false; return false; }
		});
		if(!bResult) { /**/ console.log("checkbox check failed"); /**/ return false; }

		$filter.find("select, input:not(:radio,:checkbox,:button,.search-query,[type=hidden]), textarea").each(function()
		{
			//console.log('select, input:not(:radio,:checkbox,:button,.search-query), textarea');
			$this = $(this);
			if($this.data('is-preference')) return true;
			if($this.closest(".controls.hidden-filter").length) return true;
			if($this.val() !== $this.data("default-value"))
			{
				// console.log($this.attr("id"), "tested:", $this.val(), "≠", $this.data("default-value"));
				bResult = false;
				return false;
			}
		});
		if(!bResult) { /** console.log("other check failed"); /**/ return false; }

		return true;

	}

	Q.DATA_TABLE.prototype.fnInitFilters = function ( )
	{
		//alert("Filters initted!");
		var that = this;
		this.$.formFilters = $("#"+this.aOptions.sDomIdPrefix+"Filters");
		this.$.filtersPanel = this.$.formFilters;
		this.$.aFilters = this.$.formFilters.find("div.q-filter");
		//alert("#"+this.aOptions.sDomIdPrefix+"Filters");

		this.$.filtersPanel.find(".toggleButtonsHolder").find(".btnApplyFilters, .btnMoreFilters").on('click', function()
		{
			that.$.filtersPanel.toggleClass("expanded");
			that.fnAutoSize();
		});

		///this.$.formFilters.parent().toggleable();

		//console.log("this.$.formFilters: %o", this.$.formFilters);
		var $closeBtn = $(
				'<div class="btnResetAllFilters btn btn-outline-primary" style="margin-left: 18px; height: 28px; line-height: 26px; padding: 0px 10px;">\
					<a class="qui-toggleable-close-a d-table-cell">Очистить фильтры</a>\
				</div>'
		);

		$closeBtn.click($.proxy(function() {
			this.$.formFilters.find('div.q-filter.setted a.close').click();
		}, this));
		this.$.filtersPanel.find(".toggleButtonsHolder").append($closeBtn);

		// this.fnLoadFiltersCollapseState();

		// Настроим кнопки очистки фильтров
		// Для начала определим, какие значения считать значениями по умолчанию.
		this.$.aFilters.each(function()
		{
			var $filter = $(this);

			var oDefaultIdsByName = {};
			var $aRadio = $filter.find("input:radio");
			$aRadio.each(function()
			{
				var sName = $(this).attr("name");

				if(typeof(oDefaultIdsByName[sName])==="undefined")
				{
					var mResetTo = $(this).data("reset-to");
					if( typeof(mResetTo) == 'undefined' ||  mResetTo === null ) mResetTo = "";

					var $aRadioGroup = $aRadio.filter('[name="'+sName+'"]');
					//console.log("$aRadioGroup = %o",$aRadioGroup);
					var $r = $aRadioGroup.filter('[value="'+mResetTo+'"]');
					if(! $r.length) $r = $aRadioGroup.filter('[value="0"]');
					if(! $r.length) $r = $aRadioGroup.filter(':checked');
					if(! $r.length) $r = null;
					oDefaultIdsByName[sName] = ($r === null) ? null : $r.attr("id");
				}
				//sconsole.log(sName," → ", oDefaultIdsByName[sName], $(this).attr("id"), ($(this).attr("id")===oDefaultIdsByName[sName]));
				var idDefault = oDefaultIdsByName[sName];

				$(this).data("default-checked", ($(this).attr("id")===idDefault) );
			});

			$filter.find("input:checkbox").each(function()
			{
				var mResetTo = $(this).data("reset-to");
				if( typeof(mResetTo) == 'undefined' ||  mResetTo === null )
					mResetTo = ! $(this).closest(".q-checkbox-group").length && (typeof($(this).attr("checked"))!=="undefined");
					//mResetTo = false;

				var mResetTo = !!Number(mResetTo);

				$(this).data("default-checked", mResetTo); //(typeof($(this).attr("checked"))!=="undefined"));
			});

			$filter.find("select").each(function()
			{
				var mResetTo = $(this).data("reset-to");
				if( typeof(mResetTo) == 'undefined' ||  mResetTo === null ) mResetTo = "";

				if($(this).find('option[value="'+mResetTo+'"]').length) { $(this).data("default-value", mResetTo); }
				else if($(this).find('option[value="0"]').length) { $(this).data("default-value", "0"); }
				else $(this).data("default-value", $(this).val());
			});


			$filter.find("input:not(:radio,:checkbox,:button,.search-query,[type=hidden]), textarea").each(function()
			{
				$(this).data("default-value", $(this).val());
			});

			// Теперь посмотрим, а не свернут ли он
			/*
			var sLabel = $filter.find('label.control-label').text();
			if(typeof(that.oFilterStates[sLabel]) !== 'undefined')
				$filter.toggleClass("collapsed", that.oFilterStates[sLabel]);
			*/

		});

		this.$.aFilters.each(function()
		{
			var $filter = $(this);
			$filter.toggleClass("setted", ! that.fnIsFilterDefault($filter) );
		});
		this.fnUpdateFiltersCount();

		// Навесим событие на кнопки очистки
		this.$.aFilters.find("a.close").tooltip({placement:"left"});
		this.$.aFilters.on('click', "label.control-label", function(e)
		{
			var $target = $(e.target);
			if($target.is('label.control-label'))
			{
				/*
				var sLabel = $target.text();
				var $qFilter = $target.closest(".q-filter").toggleClass("collapsed");
				that.oFilterStates[sLabel] = $qFilter.is(".collapsed");
				that.fnSaveFiltersCollapseState();
				*/
			}
		});
		this.$.aFilters.on('click', "a.close", function(e)
		{
			var $btnClear = $(e.currentTarget);
			var $filter = $btnClear.parent("div.q-filter");

			$filter.find("input:checkbox, input:radio").each(function()
			{
				//console.log('$filter.find("input:checkbox")');
				var $this = $(this);
				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;

				if($this.is(":radio")) $this.parent().removeClass("active");

				var bChecked = $this.data("default-checked");
				if(bChecked) that.oTable.aFiltersCurrentValues[$this.data('name')] = $this.val();
				if(bChecked && !$this.is(":checked"))
				{
					$this.prop("checked", "checked");
					$this.change();
					if($this.is(":radio")) $this.parent().addClass("active");
				}
				else if(!bChecked && $this.is(":checked"))
				{
					$this.removeAttr("checked");
					$this.change();
				}

			});

			$filter.find("select, input:not(:radio,:checkbox,:button,.search-query,[type=hidden]), textarea").each(function()
			{
				// console.log('select, input:not(:radio,:checkbox,:button,.search-query), textarea');
				var $this = $(this);
				if($this.prop('disabled')) return false;
				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;
				if($this.val() !== $this.data("default-value"))
				{
					//console.log('$this.data("default-value")',$this.data("default-value"));
					$this.val($this.data("default-value"));
					$this.change();
				}

				// Отдельно обработаем случай с автокомплит.
				// #TODO: FIXME Too complicated
				if($this.is(".qfield-autocomplete-restricted"))
					$this.show().closest(".controls").find(".form-ac-selected").parent().hide();
			});

			$filter.toggleClass("setted", false );
			that.fnUpdateFiltersCount();

			that.fnAutoSize(true);
		});

		// Научим прятать заголовок в случае когда спрятаны все фильтры
		this.$.aFilters.on("hidden.field shown.field updated.field", function(e)
		{
			var $filter = $(e.target).closest("div.q-filter");
			//console.log("hidden.field shown.field updated.field : %o — %o", e, $filter.find('input, select, textarea'));
			$filter.toggleClass("all-hidden", !$filter.find("div.controls:not(.hidden-by-condition,.hidden-filter)").length || !$filter.find('input, select, textarea').length);
		});
		// Заодно в момент инициализации спрячем заголовки пустых фильтров
		this.$.aFilters.each(function()
		{
			var $filter = $(this);
			$filter.toggleClass("all-hidden", !$filter.find("div.controls:not(.hidden-by-condition,.hidden-filter)").length || !$filter.find('input, select, textarea').length);
		});

		// Настроим события изменения фильтра → по ним надо будет обновлять форму
		this.oTable.aFiltersCurrentValues = {};
		this.$.aFilters.each(function()
		{
			var $filter = $(this);

			$filter.on('click', "input:radio", function(e)
			{
				var this_ = e.currentTarget;
				var $this = $(this_);
				var sVal = $this.val(); // т.к. мы на него кликнули, значит его значение нам и нужно.
				// if(! isset(that.oTable.aFiltersCurrentValues[this_.name])) that.oTable.aFiltersCurrentValues[this_.name] = sVal;
				if(sVal != that.oTable.aFiltersCurrentValues[this_.name])
				{
					that.oTable.aFiltersCurrentValues[this_.name] = sVal;
					that.oTable.page( 0 ).draw( 'page' ); // тогда переходим на первую страницу с обязательным обновлением данных
				}
				// if(!$(that.aOptions.sFrameAs).is(".EmbededList")) that.$.SidePanelScrollable.resize(); // также относится к скроллу (см. выше)

				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;
				$filter.toggleClass("setted", ! that.fnIsFilterDefault($filter) );
				that.fnUpdateFiltersCount();

				if($this.is('[data-preserve="1"]')) QForm.fnProcessReversedField(this);
			});

			$filter.on('change', "input:checkbox", function(e)
			{
				var this_ = e.currentTarget;
				var $this = $(this_);
				//console.log("Filter checkbox changed!");
				if($this.is(":checked")) var sVal = $this.val();
				else var sVal = "";
				// if(! isset(that.oTable.aFiltersCurrentValues[this_.name])) that.oTable.aFiltersCurrentValues[this_.name] = sVal;
				//if(sVal != that.oTable.aFiltersCurrentValues[this_.name])
				//{
					that.oTable.aFiltersCurrentValues[this_.name] = sVal;
					that.oTable.page( 0 ).draw( 'page' ); // тогда переходим на первую страницу с обязательным обновлением данных
				//}

				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;
				$filter.toggleClass("setted", ! that.fnIsFilterDefault($filter) );
				that.fnUpdateFiltersCount();

				if($this.is('[data-preserve="1"]')) QForm.fnProcessReversedField(this);
			});


			$filter.on('change', "select", function(e)
			{
				var this_ = e.currentTarget;
				var $this = $(this_);

				var sVal = $this.val();
				// if(! isset(that.oTable.aFiltersCurrentValues[this_.name])) that.oTable.aFiltersCurrentValues[this_.name] = sVal;
				if(sVal != that.oTable.aFiltersCurrentValues[this_.name])
				{
					that.oTable.aFiltersCurrentValues[this_.name] = sVal;
					that.oTable.page( 0 ).draw( 'page' ); // тогда переходим на первую страницу с обязательным обновлением данных
				}
				// if(!$(that.aOptions.sFrameAs).is(".EmbededList")) that.$.SidePanelScrollable.resize();

				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;
				$filter.toggleClass("setted", ! that.fnIsFilterDefault($filter) );
				that.fnUpdateFiltersCount();

				if($this.is('[data-preserve="1"]')) QForm.fnProcessReversedField(this);

			});

			$filter.on('blur keyup change', "input:not(:radio,:checkbox,:button,.search-query), textarea", function(e)  // по нажатию клавиши или при расфокусировки
			{
				var this_ = e.currentTarget;
				var $this = $(this_);

				if(e.type === 'focusout' && $this.is(".qfield-autocomplete-restricted")) return;
				//console.log("event type=", e.type, "; qfield-autocomplete=", $this.is(".qfield-autocomplete-restricted"));
				//console.log("triggered!");
				//console.dir(this_);
				// Должно срабатывать только если нажали ENTER. Проверим на это дело.
				if(e.type === 'keyup' && e.keyCode !== 10 && e.keyCode !== 13) return;
				var sVal = $this.val();
				// if(! isset(that.oTable.aFiltersCurrentValues[this_.name])) that.oTable.aFiltersCurrentValues[this_.name] = sVal;
				if(sVal != that.oTable.aFiltersCurrentValues[this_.name])
				{
					that.oTable.aFiltersCurrentValues[this_.name] = sVal;
					that.oTable.page( 0 ).draw( 'page' ); // тогда переходим на первую страницу с обязательным обновлением данных
				}
				// if(!$(that.aOptions.sFrameAs).is(".EmbededList")) that.$.SidePanelScrollable.resize();

				if($this.data('is-preference')) return;
				if($this.closest(".controls.hidden-filter").length) return;
				$filter.toggleClass("setted", ! that.fnIsFilterDefault($filter) );
				that.fnUpdateFiltersCount();

				if($this.is('[data-preserve="1"]')) QForm.fnProcessReversedField(this);
			});


		});

	};

	Q.DATA_TABLE.prototype.fnSaveFiltersCollapseState = function ( )
	{
		console.dir(this.oFilterStates);
		var oSettings = this.oTable.settings()[0];
		localStorage.setItem( 'QFilters/'+oSettings.sCookiePrefix, JSON.stringify(this.oFilterStates) );
	}

	Q.DATA_TABLE.prototype.fnLoadFiltersCollapseState = function ( )
	{
		var oSettings = this.oTable.settings()[0];
		this.oFilterStates = JSON.parse(localStorage.getItem( 'QFilters/'+oSettings.sCookiePrefix ));
		if(empty(this.oFilterStates)) this.oFilterStates = {};
	}

	Q.DATA_TABLE.prototype.fnInitKnowledgeLinks = function ( )
	{
		var that = this;

		//knowledgelinks-panel

	};

	Q.DATA_TABLE.prototype.getNewSize = function ( )
	{
		// return; // убрал

		if(this.aOptions.bFramed)
		{
			var w;
			var h;

			var iBalastHeight = 0;
			if(this.$.bInitted)
			{
				this.$.DataTable_wrapper.find(".fg-toolbar").each(function()
				{
					iBalastHeight += Number($(this).height());
				} );
				iBalastHeight += Number(this.$.DataTable_wrapper.find("div.dataTables_scrollHeadInner").height());
			}
			else
			{
				iBalastHeight = 64;
			}

			iBalastHeight += 20 + 21; // не знаю почему, но такова погрешность. // 21 — футер таблиц

			if(!empty(this.aOptions.iListWidth))
				w = this.aOptions.iListWidth;//-136;
			else
				w = $(this.$.MainPanel).width()-18;// 18 — scroll; //-136;

			if(!empty(this.aOptions.iListHeight))
				h = this.aOptions.iListHeight;//-76;
			else
				h = $(this.aOptions.sFrameAs).outerHeight();//-116;


			//console.log("this.aOptions.iListHeight="+this.aOptions.iListHeight);

			if(this.aOptions.bHasTabs) iBalastHeight += 29;
			//////console.log("sFrameAs height:"+$(this.aOptions.sFrameAs).height());
			if(this.aOptions.sFrameAs == "body") //#FIXME @todo
			{
				// Попробуем вычислить высоту «баласта» автоматически.
				this.$.MainTbl.parents("div.dataTables_scrollBody").eq(0).height(1000);
				var iBodyHeight = $.getDocHeight(); //$("body").height() + $(document).scrollTop();
				iBalastHeight = iBodyHeight - 1000; // 2 — запас
				h = $("body").height();
			}

			if(this.iType == DATA_TABLE_TYPEFULL) h -= iBalastHeight; //87;

			/*
			if(!this.aOptions.bHideButtons)
			{
				if($(this.aOptions.sFrameAs).is(".EmbededList")) w -= 102;
				else w -= 136;
			}
			*/

			//console.log("h="+h);
			if($(this.aOptions.sFrameAs).is(".EmbededList")) h -= 60; // Для встроенного списка 25 пикселей приходится убирать.

			return {w:w, h:h};

		}
		else
		{
			return false
		}
	};

	Q.DATA_TABLE.prototype.fnCalculateHeaderOffset = function()
	{
		var outerHeight = $("#SiteNavBar").height();

		this.$.MainTbl
			      .closest('.qlist-container')
			      .find('.fh-fixedHeader')
			      .each(function()
			      {
			          outerHeight += $(this).outerHeight();
			      });

		return outerHeight;
	}

	Q.DATA_TABLE.prototype.fnSetStickyHeader = function()
	{
		var stickyBitStickyOffset = $("#SiteNavBar").height();
		this.$.MainTbl
		      .closest('.qlist-container')
		      .find('.fh-fixedHeader').each(function()
		{
		      var $this = $(this);
		      $this.stickybits({ stickyBitStickyOffset });
		      stickyBitStickyOffset += $this.outerHeight();
		});

		this.$.MainTbl
		      .closest('.qlist-container')
		      .find('.dataTables-footer')
		      .stickybits({ verticalPosition: 'bottom' });

	}

	Q.DATA_TABLE.prototype.fnAutoSize = function (bReloadData, oReloadSettings)
	{
		if(bReloadData === undefined) bReloadData = false;

		if(!oReloadSettings)
			oReloadSettings = {callback: null, resetPaging: true};

		if(bReloadData)
			this.oTable.ajax.reload(oReloadSettings.callback, oReloadSettings.resetPaging);


		if(!this.aOptions.bFramed)
		{
			this.fnSetStickyHeader();
			this.oTable.fixedHeader.headerOffset( this.fnCalculateHeaderOffset() );
		}
		else
		{
			// if(!bReloadData)
			// 	this.oTable.columns.adjust().draw(); // 'false' предотвращает бессмысленные ajax-запросы к серверу (они называют это  “recalculating”;)))
		}
	};

	Q.DATA_TABLE.prototype.fnUpdateFormTabsCounts = function()
	{
		// console.log("Q.DATA_TABLE.prototype.fnUpdateFormTabsCounts: %o",this.$);
		var $formParent = this.$.DataTable_wrapper.closest("form");
		var oQFormObject;
		if((oQFormObject = $formParent.data("qform-object")))
		{
			oQFormObject.fnUpdateTabsCounts();
		}

	}

	Q.DATA_TABLE.prototype.fnOpenForm = function ( id , fnOnOpen, sbDublicate)
	{
		var oQDataTable = this;
		//console.log("Q.DATA_TABLE.prototype.fnOpenForm");
		//console.dir(this.aOptions);
		if(sbDublicate == "dublicate")
		{
			QForm.fnOpenDublForm( this.aOptions.sEntity, id , this.aOptions.aExternVars, fnOnOpen, this.aOptions.sFormTitle , this.aOptions.sParentEntity);
		}
		else
		{
			QForm.fnOpenForm( this.aOptions.sEntity, id , this.aOptions.aExternVars, fnOnOpen, this.aOptions.sFormTitle , this.aOptions.sParentEntity);
		}
	};

	Q.DATA_TABLE.prototype.fnOpenView = function ( id , fnOnOpen)
	{
		var oQDataTable = this;

		QForm.fnOpenView( this.aOptions.sEntity, id , this.aOptions.aExternVars, fnOnOpen, this.aOptions.sFormTitle , this.aOptions.sParentEntity);
	};

	Q.DATA_TABLE.prototype.fnDeleteEntries = function ( ids, fnCallback, bForce )
	{
		var oThisQ = this;
		if(typeof(bForce) == 'undefined') bForce = false;
		$.ajax
		({
			type: "GET", // для уменьшения нагрузки шлем гетом. (POST обменивается еще и хедерами)
			dataType: "json",
			url: this.aOptions.sDeleteUrl,
			data: {"id[]":ids, embeded:1, 'q-force': bForce?1:0},
			beforeSend: function()
			{
				//Q.fnShowLoader("Подождите, идёт удаление…");
			},
			complete: function()
			{
				//Q.fnCloseLoader();
			},
			success: function(jsonobj, textStatus, jqXHR)
			{

				fnCallback(jsonobj, textStatus, jqXHR);

				if(jsonobj != null)
				{
					if(Number(jsonobj.success))
					{
						const oReloadSettings = {callback: null, resetPaging: false};
						oThisQ.oTable.rows("tr.row_selected").remove().draw(oReloadSettings.resetPaging);
						$("tr.row_selected").remove();
						// Обновим содержание таблицы
						// true означает, что данные надо заново подтянуть из Web
						oThisQ.fnAutoSize(true, oReloadSettings);
					}
					else
					{
						if(!empty(jsonobj.warning))
						{
							//alert("!!!");
							if(jsonobj.warning.critical)
							{
								Q.fnAlertError(jsonobj.warning.message);
							}
							else
							{
								//Q.fnAlert(mResponse.warning.message);
								//Q.fnConfirm(mResponse.warning.message);
								Q.fnConfirm(jsonobj.warning.message, $.proxy(function($btn, $Modal)
								{
									$Modal.modal('hide');
									oThisQ.fnDeleteEntries(ids, fnCallback, true);

								}, this), 'Продолжить', 'warning');
							}
						}

						// var sMsg;
						// sMsg = "Ошибка при удалении!";
						// if(jsonobj.error)
						// 	sMsg += "<br /><b>Ответ с сервера:</b> "
						// 		    +jsonobj.error;

						// Q.fnAlertError(sMsg);
					}
				}
				else
				{
					Q.fnAlertError("Получен неправильный ответ с сервера!");
				}

			}
			/**
			,
			failed: function()
			{
				//console.log("deleting failed");
				Q.fnAlertError("Проверьте подключение к Интернет");
			}
			**/
		});

	}

	/**
	 * Возвращает идентификаторы выделенных строк в таблице
	 */
	Q.DATA_TABLE.prototype.fnGetSelected = function (  )
	{
		return this.aSelectedIds;
	};

	Q.DATA_TABLE.prototype.fnUpdateSelection = function( )
	{
		this.fnClearSelection();
		var oTbl = this.oTable;
		var that = this;
		this.$.MainTbl.find("tr.row_selected").each(function()
		{
			//alert($(this).html());
			var aData = oTbl.row(this).data();
			if(!empty(aData)) // Исключим группировочные строки.
			{
				var mQFormId = aData.mQFormId;
				var bQAccessEditMarker   = !!Number(aData.bAccess_edit);
				var bQAccessDeleteMarker = !!Number(aData.bAccess_delete);
				that.fnAddSelected(mQFormId, bQAccessEditMarker, bQAccessDeleteMarker);
			}
		});

		if(this.fnGetSelected().length) qdebuginfo("Выбраны записи с id IN ("+this.fnGetSelected().join(', ') + ")");
	};

	/**
	 *
	 */
	Q.DATA_TABLE.prototype.fnAddSelected = function( mId , bQAccessEditMarker, bQAccessDeleteMarker)
	{
		// Сначала проверим, нет ли у нас уже такого…
		if(! common.deleteElementByValue(mId, this.aSelectedIds))
		{
			this.aSelectedIds[this.aSelectedIds.length] = mId;

			this.bAccessMarker_edit = this.bAccessMarker_edit && bQAccessEditMarker;
			this.bAccessMarker_delete = this.bAccessMarker_delete && bQAccessDeleteMarker;

			this.fnRefreshOperateCol();
		}
	};

	Q.DATA_TABLE.prototype.fnClearSelection = function( mId )
	{
		this.aSelectedIds = [];
		this.bAccessMarker_edit = 1;
		this.bAccessMarker_delete = 1;
		this.fnRefreshOperateCol();
	};

	Q.DATA_TABLE.prototype.fnToggleRowSelection = function($tr, bSelect)
	{
		$tr.toggleClass("row_selected", !!bSelect).find("td.checkbox input").prop("checked", !!bSelect);
	}

	Q.DATA_TABLE.prototype.fnRefreshOperateCol = function()
	{
		if(this.bEditDisabled == undefined) this.bEditDisabled = true; // «статическая» переменная, которая позволит сократить обращения к DOM.
		if(this.bDeleteDisabled == undefined) this.bDeleteDisabled = true; // «статическая» переменная, которая позволит сократить обращения к DOM.
		// Кстати, по умолчанию они равны true, т.к. изначально кнопки и должны быть disabled
		/*
		 * Для кнопки редактирования
		 */
		if(this.aSelectedIds.length > 1) // Выбрано много записей
		{
			/**/
			if(this.aOptions.bMultiEdit && this.bAccessMarker_edit) this.bEditDisabled = false;
			else
			{
				if(!this.bEditDisabled)
					this.bEditDisabled = true;
			}
			/**/
		}
		else if(this.aSelectedIds.length == 1) // Выбрана одна запись
		{
			if(this.bEditDisabled)
				this.bEditDisabled = false;
		}
		else // Ничего не выбрано ( i.e. this.aSelectedIds.length == 0 )
		{
			if(!this.bEditDisabled)
				this.bEditDisabled = true;
		}

		if(this.bEditDisabled)
		{
			if(!this.aOptions.bHideEditBtn)
			{
				this.$.btnEdit.show();
				this.$.btnView.hide();
			}
		}
		else
		{
			if(!this.bAccessMarker_edit)
			{
				this.$.btnEdit.hide();
				this.$.btnView.show();
			}
		}

		this.$.btnEdit.attr("disabled", this.bEditDisabled );
		this.$.btnDubl.attr("disabled", !(this.aSelectedIds.length == 1) );
		this.$.btnView.attr("disabled", this.bEditDisabled );

		/*
		 * Для кнопки удаления
		 */

		if(this.aSelectedIds.length > 0) // Выбраны одна или несколько записей
		{
			if(this.bDeleteDisabled)
				this.bDeleteDisabled = false;
		}
		else // ничего не выбрано
		{
			if(!this.bDeleteDisabled)
				this.bDeleteDisabled = true;
		}

		//console.log("this.bDeleteDisabled = "+this.bDeleteDisabled);
		//console.log("!this.bAccessMarker_delete = "+!this.bAccessMarker_delete);
		//console.log("disable → "+(this.bDeleteDisabled || !this.bAccessMarker_delete));
		this.$.btnDelete.attr("disabled", this.bDeleteDisabled || !this.bAccessMarker_delete);

		var that =this;
		this.$.ButtonsPanel
			.find("button.mybtn")
				.each(function()
				{
					var bSelectionOnly = $(this).data("selectiononly");
					//alert(bSelectionOnly);
					var cntIds = that.aSelectedIds.length;
					var bDisable;
					if(!bSelectionOnly) bDisable = true;
					else
					{
						if(bSelectionOnly == 1 && cntIds == 1) bDisable = true;
						else if(bSelectionOnly == 2 && cntIds >= 1)  bDisable = true;
						else bDisable = false;
					}
					if( bDisable )
					{
						$(this)
							.attr("disabled", "0")
							.removeAttr("disabled");
					}
					else
					{
						$(this).attr("disabled", "1");
					}
				})


	};

	/////////////////////
	///// Типы таблицы
	/////////////////////
	/**
	 * Полная таблица со всеми примочками и кнопками добавить/изменить/etc справа
	 * @constant
	 */
	window.DATA_TABLE_TYPEFULL = 1;
	/**
	 * Уменьшенный вариант — ничего лишнего. Используется в информационном подвале и в формах
	 * @constant
	 */
	window.DATA_TABLE_MINI = 2;
	/**
	 * В этом случае за основу не берется ни один готовый шаблон, все задается самостоятельно
	 * @constant
	 * @todo
	 */
	window.DATA_TABLE_CUSTOM = -1;
	//////////////////////////////////

	/**
	 * @namespace Содержит некоторые общие методы и свойства для работы dataTables
	 */
	Q.dataTables = {};

	Q.dataTables.fnPreQuery = function(oDataTable, sSource, aoData, fnCallback)
	{
		//console.log("fnPreQuery called");

		var that = oDataTable;

		var oSettings = oDataTable.api().settings()[0];
		//console.log("dataTable settings…");
		//console.dir(oSettings);

		if(empty(that.$dataTablesWrapper))
		{
			that.$dataTablesWrapper = $(that).parents("div.dataTables_wrapper");
			//alert(that.$dataTablesWrapper.html());
		}

		//aoData.filters = "dddd";

		var oQTbl = $(that).data("q-data-table");
		/***
		if(empty(oQTbl))
		{
//			console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!");
			oQTbl = oDataTable.data("qDataTable");
		}
		***/

		$("#"+oQTbl.aOptions.sDomIdPrefix+"Filters").find("div.q-filter").each(function()
		{
			var bAsDefault = true;
			var $filter = $(this);
			$filter.find("input, select, textarea").each(function()
			{
		        //console.log("test");
		        if(this.name) // только те, у которых есть имя =)
	        	{
	        		//alert(this.type);
	        		var $this = $(this);
	        		if(this.type=="checkbox" || this.type=="radio") if(!$this.is(":checked")) return;
	        		//console.log('$this.is("qfield-checkbox-nullhack")=',$this.is("qfield-checkbox-nullhack"),'; $this.next().is(":checked")=',$this.next().is(":checked"));
	        		if($this.is(".qfield-checkbox-nullhack") && $this.next().is(":checked")) return;
	        		//if() if(!$(this).is(":selected")) return;
	        		var sVal = $this.val();
	        		var sVariableName = this.name.split(/^filter_/).join("");
	        		var aVariableNAme_splitted = sVariableName.split('[]');
	        		if(aVariableNAme_splitted.length==1) sVariableName = "filters["+sVariableName+"]";
	        		else sVariableName = "filters["+aVariableNAme_splitted[0]+"][]";

	        		if($(this).closest(".controls").is(".hidden-by-condition")) sVal = "";

	        		aoData[aoData.length] = {name:sVariableName, value:sVal};
	        	}
		    });
			//console.log("bAsDefault="+bAsDefault+";");

		    //if(bAsDefault) if(!$filter.is(".default-setted")) $filter.addClass("default-setted");
		    //else $filter.removeClass("default-setted");
		});

		return {sSource:sSource, aoData:aoData, fnCallback:fnCallback};

	}

	Q.dataTables.fnColumnProccessor = function(nTd, oDataTable)
	{
		var $td = $(nTd);
		if( ! $td.is(".initted") )
		{
			var oPos = oDataTable.cell( nTd ).index();
			var iPos = oPos.column;
			var oSettings = oDataTable.settings()[0].aoColumns[iPos];

			//console.log("oSettings: %o", oSettings);

			/***/
			var sMinWidth = oSettings.sMinWidth;
			var sMaxWidth = oSettings.sMaxWidth;
			var sWidth = oSettings.width;

			var oCss = {};
			if(!empty(sMinWidth)) oCss["min-width"] = sMinWidth;
			if(!empty(sMaxWidth)) oCss["max-width"] = sMaxWidth;
			if(!empty(sWidth)) oCss["width"] = sWidth;

			$(nTd).css(oCss);
			/***/

			if(oSettings.bCellHint)
			{
				//console.log("cell hint");
				var aData = oDataTable.row(nTd.parentNode).data();
				var sCellHint = aData[oSettings.sName + "_qhint"];
				if(sCellHint != undefined)
				{
					$(nTd)
						.tooltip({title:sCellHint, delay: {show:500, hide:100}})
						.prepend('<div class="corner"><div class="rectangle"></div></div>');
				}
			}

			if(oSettings.bCellClass)
			{
				//console.log("cell hint");
				var aData = oDataTable.row(nTd.parentNode).data();
				var sCellClass = aData[oSettings.sName + "_qcss-class"];
				if(sCellClass != undefined)
				{
					$(nTd).addClass(sCellClass);
				}
			}

			//console.log("settings for col #"+iPos);
			//console.dir(oSettings);
			switch(oSettings.sQType) // @TODO Сделать это по-другому.
			{
				/****/
				case "slider":

					var sVal = $td.text();
					//alert("!!"+sVal+"%%");
					$td.html('<div class="progress"><div class="bar" style="width: '+sVal+'%;"></div></div>');
					break;

				/****/

				/***
				case "icon":
					var sVal = $td.text();
					//alert(sVal);
					//alert("!!"+sVal+"%%");
					$td.html('<i class="icon-'+sVal+'"/>');// .find("i").addClass("icon-"+sVal);

					break;
				/***/

				case "files":
					var iCount = Number($td.text());
					if(iCount)
					{
						$td.html('<span style="white-space:nowrap;"><a class="open-files-link" href="#"><i class="icon-attachment"/></a>&nbsp;<sub>'+iCount+'</sub></span>');
						var $btn = $td.find("a.open-files-link");
						$btn.data("content-loaded", false);


						$btn.popover
						({
							placement:function wheretoplace()
							{
							    var iHeight = window.innerHeight;
							    var oOffset = $btn.offset();
							    if(iHeight - oOffset.top > 300) return "bottom"
							    else return 'top';
							},
							html:true,
							title:"Файлы",
							content:"<i>Загружаю…</i>",
							trigger: "manual"
						});
						$btn.click(function(e)
						{

							$("div.tooltip, div.popover").remove(); // Хак, который уберет все открытые тултипы и поповеры, чтобы избежать глюков

							$btn.popover("toggle");

							// if(!$btn.data("content-loaded"))
							// {

								var aData = oDataTable.row(nTd.parentNode).data();
								var id = aData[oSettings.sEntityIdField];
								var sPrefix = oSettings.sEntityPrefix;

								$.ajax
								({
									method: "GET",
									url: "/fileslist",
									dataType: "html",
									data: {entity:oSettings.sEntity, id:id, prefix:sPrefix},
									success: function(sHtml)
									{
										var oPopover = $btn.data("bs.popover");
										oPopover.config.animation = false; // временно выключим анимацию
										$btn.data("content-loaded", true).popover("show"); // перерисуем
										$(oPopover.tip).find('.popover-body').html(sHtml);
										oPopover.config.animation = true;

									}
								});
								$btn.data("content-loaded", true);
						//	}

							e.stopPropagation();
							return false;
						});

						//var
					}
					break;
			}
			$td.addClass("initted");
		}
	}

	Q.dataTables.fnWaitForIframe = function(sIframe, fnCallback)
	{
		/***
		nIframe = document.getElementById(sIframe);
        if (nIframe.readyState != "complete") {
            setTimeout(function(){Q.dataTables.fnWaitForIframe(fnCallback);}, 200);
        } else {
            fnCallback();
        }
        ***/

        $("#"+sIframe).ready(function()
        {
        	fnCallback();
        })

	}

	/**
	 * Значения по умолчанию для dataTables
	 * @example
	 *		var options = {sAjaxSource:"/example.php"};
	 *		$.extend(true, options, oDefaultTableOptions)
	 *		options.sCookiePrefix += "example_";
	 * 		$("#example").dataTables(options);
	 *
	 * @param string sAjaxSource ссылка на Ajax источник
	 * @param string sCookiePrefix Префикс для кукисов. Для каждой таблицы д/б уникальным. Уже задан, поэтому рекоммендую делать так: Пр. oTableOptions.sCookie += "ns_persons_1";
	 */
	Q.dataTables.oDefaultTableOptions =
	{
		"bProcessing": true,
		"bServerSide": true,
		//"bJQueryUI": true, // использовать тему jquery UI
		// "sPaginationType": "bootstrap",
		// "sDom": "'H'<'row'<'col-8'<'place4colvis'><'place4btns'<'btn btn-light form-control refreshButton loading'<'i'>>>>r<'col-4 align-right'f>>t<'row dataTables-footer'<'col-4'i><'col-4'l><'col-4 align-right'p>>",
		"sDom": "'H'<'row fh-fixedHeader align-items-center'<'col-6 pl-0 pr-0' 'i'><'col-6 align-right pr-0' 'p'>><'row fh-fixedHeader'<'col-8'<'place4colvis'><'place4btns'<'btn btn-light form-control refreshButton loading'<'i'>>>>r<'col-4 align-right'f>>t<'row dataTables-footer'<'col-6'i><'col-6 align-right'p>>",
//		"sDom": "'H'<'row'<'col-8'<'place4colvis'><'place4btns'<'btn refreshButton loading'<'i'>>>>r<'col-2'f>>t<'row dataTables-footer'<'col-5'i><'col-5'p>>",
		"bDeferRender": true, // не знаю, что это означает, но это позволило реализовать treeview
        "bStateSave": true,
        // "bScrollAutoCss": true,
        /*"bScrollInfinite": true,*/
        "aLengthMenu": [[25, 50, 100, 150, 250, 500, 1000, -1], [25, 50, 100, 150, 250, 500, 1000, "все (не рекомендуется)"]],
        // "bScrollCollapse": false,
		// "bAutoWidth": true, // без этого почему-то не работает.
        "stateSaveCallback": function (oSettings, oData)
        {
            // Не хочу запоминать эти настройки.
            delete oData.iStart;
            delete oData.iEnd;
            delete oData.iLength;
            delete oData.aoSearchCols;
            localStorage.setItem( 'DataTables/'+oSettings.oInit.sCookiePrefix, JSON.stringify(oData) );
        },
        "stateLoadCallback": function (oSettings)
        {

			var oData = JSON.parse( localStorage.getItem('DataTables/'+oSettings.oInit.sCookiePrefix ) );

			if(oData !== null)
			{
				if(oData.aaSorting === undefined) return null; // хак. иногда почему-то система не находит данные о сортировках и тогда вообще падает.

				var bInfinite=oSettings.oScroll.bInfinite;
				// Т.к. эти настройки мы не запоминали, их надо будет сейчас «сгенерировать».
				oData.iStart		= (bInfinite ? 0 : oSettings._iDisplayStart),
				oData.iEnd			= (bInfinite ? oSettings._iDisplayLength : oSettings._iDisplayEnd),
				oData.iLength		= oSettings._iDisplayLength;
				oData.aoSearchCols	= $.extend( true, [], oSettings.aoPreSearchCols );
				if(oData.oSearch === undefined) oData.oSearch = {}
				oData.oSearch.sSearch = "";
			}
			//console.log("Settings Loaded:");
			//console.dir(oData);
			return oData;
        },
        /**
		"oColVis":
		{
			///"aiExclude": [ 0 ], // для исключения колонки с идентификатором
			buttonText: "Колонки <span class=\"caret\"></span>"//,
			/**
			fnStateChange : function ( iColumn, bVisible )
			{
				// this.fnAdjustColumnSizing(false);
			}
			***/
		//},
		"fnServerData": function ( sSource, aoData, fnCallback )
		{
			var that = this;

			if(this.iLastQuery==undefined) this.iLastQuery = 0;
			this.iLastQuery++;

			var iQuery = this.iLastQuery;

			var tmp = function (iQuery, that)
			{
				setTimeout(function()
				{
					//console.dir("fnServerData called");
					if(iQuery === that.iLastQuery)
					{
						//console.log("iQuery="+iQuery+"; iLastQuery="+that.iLastQuery);

						var arr = Q.dataTables.fnPreQuery(that, sSource, aoData, fnCallback);
						sSource = arr.sSource;
						aoData = arr.aoData;
						fnCallback = arr.fnCallback;

						//console.log("Q.dataTables.fnPreQuery result:");
						//console.dir(arr);
						////console.dir("sSource="+sSource);
						//console.dir(aoData);

						$.ajax(
						{
							dataType: "json",
							type: "POST",
							beforeSend: function()
							{
								that.$dataTablesWrapper.find("div.refreshButton").addClass("loading");
							},
							complete: function()
							{
								that.my_bIsDrawn = false;
								that.my_bIsPreDrawn = false;
							},
							url: sSource,
							data: aoData,
							success: function(data, textStatus, jqXHR)
							{
								fnCallback(data, textStatus, jqXHR);
								that.$dataTablesWrapper.find("div.refreshButton").removeClass("loading");
							}
						} );
					}

				}, 500);

			}(iQuery, that);

			//alert(tmp);

		},
		"oLanguage":
		{
			"sLengthMenu": "Показывать _MENU_ на одной странице",
			// "sLengthMenu": "_MENU_",
			"sZeroRecords": "Ничего не найдено — извините.",
			"sInfo": "Показано с _START_ по _END_. Всего: _TOTAL_.",
			"sInfoEmpty": "Ничего не найдено.",
			"sInfoFiltered": "", //"(всего в таблице: _MAX_).", // Почему-то не работает
			"sLoadingRecords": "Пожалуйста, подождите - \n идет загрузка…",
			"sProcessing": '', //"Идёт обработка…",
			"oPaginate":
			{
				"sFirst": "&laquo;",
				"sLast": "&raquo;",
				"sNext": "",
				"sPrevious": ""
			},
			"sEmptyTable":"Записей нет",
			"sSearch": ""
		},
		"fnInitComplete": function()
		{

			this.data("qDataTable").$.DataTable_wrapper.find("tr.tr-loading-msg").remove();

			this.my_iLastPage = 0;

			var oCompleteContent =
			{
				aColumn: null,
				sClass: "",
				sContent: "",
				sLastGroup: "",
				refresh: function()
				{
					this.aColumn = null;
					this.sClass = "";
					this.sContent = "";
					this.sLastGroup = "";
				},
				get: function( aIds, aoColumns )
				{

					this.sContent += '<div class="printingSettings">';
					this.sContent += '<form class="form-horizontal" id="printingSettingsForm">';

					this.sContent += `
						<fieldset style="
						    margin-left: -15px;
						    margin-right: -15px;
						    min-width: 558px;
						">
						<div class="qform-row form-group form-material row">
						    <div class="q-field d-flex0"><label class="control-label col col-form-label" for="printingTitle">Заголовок</label>
						        <div class="col controls">
						            <div class="d-flex0 input-group" style="width:100%"><input name="title" id="printingTitle" class="qfield-string form-control" value="" type="text" maxlength="255"></div>
						        </div>
						    </div>
						</div>
						<div class="qform-row form-group form-material row">
						    <div class="q-field d-flex0"><label class="control-label col col-form-label" for="printingSubTitle">Подзаголовок</label>
						        <div class="col controls">
						            <div class="d-flex0 input-group" style="width:100%"><input name="sub_title" id="printingSubTitle" class="qfield-string form-control" value="" type="text" maxlength="255"></div>
						        </div>
						    </div>
						</div>`;

					if(aIds && aIds.length)
					{

						this.sContent += `<div class="qform-row form-group form-material row">
						    <div class="q-field d-flex0"><label class="control-label col col-form-label" for="printingSelectionChoice_0">Вывести</label>
						        <div class="col controls">
						            <div class="d-flex0 input-group">
						                <div class="form-check form-check-inline">
						                    <input name="use_selection" id="printingSelectionChoice_0" class="form-check-input form-check-input" type="radio" value="0"
						                    	${((aIds.length == 1)?'checked="checked"':'')}
						                    >
						                    <label for="printingSelectionChoice_0" class="form-check-label">
						                        Весь список
						                    </label>
						                </div>
						                <div class="form-check form-check-inline">
						                    <input name="use_selection" id="printingSelectionChoice_1" class="form-check-input form-check-input" type="radio" value="1"
						                    	${((aIds.length > 1)?'checked="checked"':'')}
						                    >
						                    <label for="printingSelectionChoice_1" class="form-check-label">
						                        Выделенные записи (${aIds.length})
						                    </label>
						                </div>
						            </div>
						        </div>
						    </div>
						</div>`;

					}

					this.sContent += `</fieldset>`;

					this.sContent += '<br>';
					this.sContent += '<h4>Выберите колонки</h4>';

					this.sContent += '<div class="ColumnsSelectorButtons"><a class="ColumnsSelectAll">Выделить все</a> | <a class="ColumnsSelectNone">Снять выделение</a> | <a class="ColumnsSelectionRestore">Сброс</a></div>';

					if(aoColumns.length > 12) this.sClass = 'doubleColumned';
					if(aoColumns.length > 24) this.sClass = 'trippleColumned';
					if(aoColumns.length > 36) this.sClass = 'fourColumned';

					this.sContent += '<ul class="'+((this.sClass!='')?(' '+this.sClass):'')+'">';
					for(var i in aoColumns)
					{
						this.aColumn = aoColumns[i];
						if(this.aColumn.sName == "QCheckBox" || this.aColumn.sName == "QDetails") continue;
						if(this.aColumn.sGroup != this.sLastGroup)
						{
							if(this.sLastGroup != "") this.sContent += "</ul></li>";
							if(this.aColumn.sGroup != "") this.sContent += '<li class="columnsGroupTitle">'+this.aColumn.sGroup+'<ul class="columnsGroupContents">';
							this.sLastGroup = this.aColumn.sGroup;
						}
						this.sContent += '<li>';
						this.sContent += '<label class="checkbox">';
						this.sContent += '<input class="columnToggler" type="checkbox"'
						            + (this.aColumn.bVisible?' checked="checked"':'')
						            + ' data-default="'+(this.aColumn.bVisible?1:0)+'"'
						            + ' name="aColumns['+this.aColumn.sName+']" value="1"'
						         +  '">';
						this.sContent += ' '+this.aColumn.sCaption;
						this.sContent += '</label>';
						this.sContent += '</li>';
					}
					if(this.sLastGroup != "") this.sContent += "</ul></li>";
					this.sContent += '</ul>';

					this.sContent += '</form>';
					this.sContent += '</div>';
					return this.sContent;
				}
			};

			//console.log("ttt");

			// учтем высоту.
			// if(this.data("qDataTable").aOptions.bFramed) this.data("qDataTable").fnAutoSizeHeight();

			var oTbl = this;
			//console.dir(oTbl);
			var oThisQ = oTbl.data("qDataTable");
			//console.dir(oThisQ);

			//this.fnSetFilteringDelay(750);
			var oSettings = oTbl.api().settings()[0];
			var aoColumns = oSettings.aoColumns;

			oThisQ.$.DataTable_wrapper.find("th.pre-hidden, td.pre-hidden").removeClass("pre-hidden");

			//console.log("let's change colvis object");
			var oColVis = new ColVis( oTbl.api().settings()[0],
			{
				buttonText: "Колонки <span class=\"caret\"></span>",
				buttons: [ {
					extend: 'colvis',
					className: 'btn-light',
					text: 'Колонки',
					columns: ':not(.notHideable)',
					columnText: function ( dt, idx, title ) {
						return aoColumns[idx].sCaption;
					}
				} ],
				"fnStateChange": function ( iColumn, bVisible )
				{
					var $aGroupsLines = oThisQ.$.MainTbl.find("tr.group-line th");
					var iColspanOld = $aGroupsLines.eq(0).attr("colspan");
					//alert($aGroupsLines.html());
					if(bVisible) $aGroupsLines.attr("colspan", iColspanOld+1);
					else $aGroupsLines.attr("colspan", iColspanOld-1);

					oThisQ.$.MainTbl.find("td:not(.initted)").each(function()
					{
						Q.dataTables.fnColumnProccessor(this, oTbl);
					});

					setTimeout(function() {
						oThisQ.fnAutoSize(true);
					}, 500);

				}
			});

			//alert($(this).find('div.place4colvis').html());
			$(oColVis.container()).appendTo(this.$dataTablesWrapper.eq(0).find("div.place4colvis"));
			// oColVis.fnRebuild();

			// _TODO: recalculate
			if(!oTbl.data("qDataTable").aOptions.sFrameAs)
				new $.fn.dataTable.FixedHeader( oTbl,
				{
					"headerOffset":  oThisQ.fnCalculateHeaderOffset()
				} );

			if(oTbl.data("qDataTable").aOptions.bResponsive)
				new $.fn.dataTable.Responsive( oTbl,
				{
					details:
					{
						type: 'column',
						target: -1
					},
					columnDefs: [ {
						className: 'control',
						orderable: false,
						targets:   -1
					} ]
				} );

			new $.fn.dataTable.ColReorder(oTbl,
			{
				fixedColumnsLeft: 1,
				fixedColumnsRight: oTbl.data("qDataTable").aOptions.bResponsive?1:0
			});

			var $inputSearch =
				this.$dataTablesWrapper
					.eq(0)
					.find("div.dataTables_filter input")
					.attr("placeholder", "Поиск")
					.attr("x-webkit-speech", "x-webkit-speech")
					.addClearButton()
					.bind('webkitspeechchange', function(e){$(this).trigger('keyup');});

			var $place4btns =
				this.$dataTablesWrapper
					.eq(0)
					.find("div.place4btns");

			//$place4btns.html("qqq");

			oTbl.data("qDataTable").$.btnRefresh = $place4btns
				//.append('<button class="btn refreshButton" id="'+oTbl.data("qDataTable").aOptions.sDomIdPrefix+'RefreshBtn"><i></i></button>')
				.find("div.refreshButton")
				.click(function()
				{
					oThisQ.fnAutoSize(true); // true — чтобы обновить!!
					return false;
				});

            if(oTbl.data("qDataTable").aOptions.aFeatures.bAllowExcel)
            {
	            $place4btns.append('<div class="btn-group exportGroup"><div class="btn btn-light form-control exportToCsvButton" style="margin-left: 9px;">Excel</div></div></div>');
            }
            else
            {
                $place4btns.append('<div class="btn-group exportGroup" style="margin-left: 9px;"></div>');
            }

            var $exportToCsvButton = $place4btns.find("div.exportToCsvButton");
			$exportToCsvButton.click(function()
			{
				//alert($(this).is(".disabled"));
				if($(this).is(".disabled")) return false;

				var aIds = oTbl.data("qDataTable").fnGetSelected();
				var sSource = oTbl.data("qDataTable").aOptions["sExcelExportUrl"];
				var oSDT = oTbl.api().settings()[0].oInit;
				var aoData = oTbl._fnAjaxParameters(oSDT);

				//Но надо еще прогнать через функцию, которая добавит нам фильтры и пр.
				var arr = Q.dataTables.fnPreQuery(oTbl, sSource, aoData, null);
				sSource = arr.sSource;
				aoData = arr.aoData;

				if(aIds.length >= 1)
				{
					if(!sSource.split("?").length) sSource += "?";
					else sSource += "&";
					sSource += "ids="+aIds.join(",");
				}

				var $form=$("#FormForExport").attr("action", sSource).empty();

				for(var i=0, len = aoData.length; i < len; i++)
				{
					$form.append($("<input/>").attr(aoData[i]));
				}


				var aIds = oTbl.data("qDataTable").fnGetSelected();
				var oSettings = oTbl.api().settings()[0];
				var aoColumns = oSettings.aoColumns;

				oCompleteContent.refresh();
				var sContent = oCompleteContent.get(aIds, aoColumns);

				Q.fnOpenModal(
				{
					sId: "QListPrintBox",
					sTitle: "XLS",
					sContent: sContent,
					oButtons:
					{
						"Экспорт" :
						{
							sClass:"btn-primary",
							fnOnClick: function()
							{
								if($(this).is(".disabled")) return false;
								var aUseData = $("#printingSettingsForm input").serializeArray(),
									typeReport = oTbl.data("qDataTable").aOptions.sEntity,
									aGets = sSource.split('/'),
									iQStation = $.inArray("q", aGets),
									typeReport = ( iQStation != -1 ) ? aGets[iQStation+1] : "",
									$exportAlertWiting = $("<div>",
																{
																	id: "exportAlertWiting",
																	html: ''
																}
															)
															.append("Файл подготавливается к скачиванию.")
															.append($("<br>"))
															.append("Это может занять некоторое время.")
															.append($("<br>"))
															.append($("<div>",
																			{
																				class: "attention",
																				html: "Пожалуйста, подождите..."
																			}
																		)
																	)
															.show();
								$("body").append($exportAlertWiting);
								// Добавляем необходимые для экспорта данные
								// Так как $.merge поддерживает слияние только двух массивов, то сливаем по парно.
								aoData = $.merge(
													$.merge(
																[{name: "typeReport", value: typeReport}], // Добавлялся в начало, не имеет принципиального значения, но оставим так, как было
																aoData
															),
													$.merge(	aUseData,
																[ /* По поводу xlsxFrom, xlsxNs_id, xlsxEmbeded, xlsxIds - ПРОКОНСУЛЬТИРОВАТЬСЯ У ИГОРЯ!!! */
																	{name: "xlsxFrom", value: oThisQ.aOptions.aExternVars.from},
																	{name: "xlsxNs_id", value: oThisQ.aOptions.aExternVars.ns_id},
																	{name: "xlsxEmbeded", value: oThisQ.aOptions.aExternVars.embeded},
																	{name: "xlsxIds", value: oTbl.data("qDataTable").fnGetSelected().join(',')}
																]
															)
												); // Объединяем массивы
								$.post(
									sSource,
									aoData,
									function (data)
									{
								 		$exportAlertWiting.hide(); // Скрываем сообщение с ожиданием
								 		if( data.result ) window.open(sSource+"&userFileName="+data.userFileName+"&download="+data.data, "_parent");
								 		else Q.fnAlertError("Произошла ошибка!");
									},
									"json"
								).
								fail(
									function(data) // Обработка ошибки
									{
										$exportAlertWiting.hide(); // Скрываем сообщение с ожиданием
										if( data.result ) window.open(sSource+"&userFileName="+data.userFileName+"&download="+data.data, "_parent");
										else Q.fnAlertError("Произошла ошибка!");
										// if( data.userFileName && data.data ) window.open((Q.WORKSPACE?'/'+Q.WORKSPACE:'')+"/create_xlsx?userFileName="+data.userFileName+"&download="+data.data, "_parent");
									}
								);


							}
						},
						"Отмена" :
						{

						}
					},
					fnOnOpen: function($Modal)
					{
						$("#printingTitle").val(oTbl.data("qDataTable").aOptions.sListTitle);

						var $buttons = $Modal.find("div.ColumnsSelectorButtons");
						var $btnAll = $buttons.children(".ColumnsSelectAll");
						var $btnNone = $buttons.children(".ColumnsSelectNone");
						var $btnRestore = $buttons.children(".ColumnsSelectionRestore");

						var $aInputs = $Modal.find("input.columnToggler");
						$btnAll.click(function()
						{
							$aInputs.attr("checked", "checked");
						});
						$btnNone.click(function()
						{
							$aInputs.attr("checked", 0).removeAttr("checked");
						});
						$btnRestore.click(function()
						{
							$aInputs.each(function()
							{
								var $this = $(this);
								if($this.data("default"))
									$this.attr("checked", "checked");
								else
									$this.attr("checked", 0).removeAttr("checked");
							});
						});

					}
				});

			});

			if(oTbl.data("qDataTable").aOptions.aFeatures.bAllowExcel)
            {
				$place4btns.find(".exportGroup").append('<div class="btn btn-light form-control printButton" style="">Печать</div>');
            }
			// Добавим кнопку «Печать»
			var $printButton = $place4btns.find("div.printButton");
			$printButton.click(function()
			{
//				console.dir(oTbl.settings()[0]);
//				console.dir(oTbl.data("qDataTable"));

				/*var aIds = oTbl.data("qDataTable").fnGetSelected();

				var oSettings = oTbl.settings()[0];
				var aoColumns = oSettings.aoColumns;

				var aColumn, sClass="", sContent = "", sLastGroup="";

				sContent += '<div class="printingSettings">';
				sContent += '<form class="form-horizontal" id="printingSettingsForm">';

				sContent += '<div class="control-group">'
				         +  '<label class="control-label" for="printingTitle">Заголовок</label>'
				         +  '<div class="controls">'
				         +  '<input type="text" id="printingTitle" name="title"'
				         +  '       placeholder="">'
				         +  '</div>'
				         +  '</div>';

				sContent += '<div class="control-group">'
				         +  '<label class="control-label" for="printingSubTitle">Подзаголовок</label>'
				         +  '<div class="controls">'
				         +  '<input type="text" id="printingSubTitle" name="sub_title"'
				         +  '       placeholder="">'
				         +  '</div>'
				         +  '</div>';

				if(aIds && aIds.length)
				{
					sContent += '<div class="control-group">'
					             +  '<label class="control-label" for="printingSelectionChoice_0">'
					             +  'Вывести'
					             +  '</label>'
					             +  '<div class="controls">'
					             +  '<div class="input-group">'
					                +  '<label for="printingSelectionChoice_0" title="" class="radio inline">'
					                +  '<input name="use_selection" id="printingSelectionChoice_0" class="form-control" type="radio" value="0"'
					                +  ((aIds.length == 1)?'checked="checked"':'')+'>'
					                +  'весь список'
					                +  '</label>'
					                +  '<label for="printingSelectionChoice_1" title="" class="radio inline">'
					                +  '<input name="use_selection" id="printingSelectionChoice_1" class="form-control" type="radio" value="1"'
					                +  ((aIds.length > 1)?'checked="checked"':'')+'>'
					                +  'Выделенные записи ('+aIds.length+')'
					                +  '</label>'
					             +  '</div>'
					             +  '</div>'
							 +  '</div>';
				}

				sContent += '<br>';
				sContent += '<h4>Выберите колонки для печати</h4>';

				sContent += '<div class="ColumnsSelectorButtons"><a class="ColumnsSelectAll">Выделить все</a> | <a class="ColumnsSelectNone">Снять выделение</a> | <a class="ColumnsSelectionRestore">Сброс</a></div>';

				if(aoColumns.length > 12) sClass = 'doubleColumned';
				if(aoColumns.length > 28) sClass = 'trippleColumned';
				if(aoColumns.length > 42) sClass = 'fourColumned';

				sContent += '<ul class="'+((sClass!='')?(' '+sClass):'')+'">';
				for(var i in aoColumns)
				{
					aColumn = aoColumns[i];
					if(aColumn.sGroup != sLastGroup)
					{
						if(sLastGroup != "") sContent += "</ul></li>";
						if(aColumn.sGroup != "") sContent += '<li class="columnsGroupTitle">'+aColumn.sGroup+'<ul class="columnsGroupContents">';
						sLastGroup = aColumn.sGroup;
					}
					sContent += '<li>';
					sContent += '<label class="checkbox">';
					sContent += '<input class="columnToggler" type="checkbox"'
					            + (aColumn.bVisible?' checked="checked"':'')
					            + ' data-default="'+(aColumn.bVisible?1:0)+'"'
					            + ' name="aColumns['+aColumn.sName+']" value="1"'
					         +  '">';
					sContent += ' '+aColumn.sCaption;
					sContent += '</label>';
					sContent += '</li>';
				}
				if(sLastGroup != "") sContent += "</ul></li>";
				sContent += '</ul>';

				sContent += '</form>';
				sContent += '</div>';
				//sContent += '</div>';*/

				var aIds = oTbl.data("qDataTable").fnGetSelected();
				var oSettings = oTbl.api().settings()[0];
				var aoColumns = oSettings.aoColumns;

				oCompleteContent.refresh();
				var sContent = oCompleteContent.get(aIds, aoColumns);

				Q.fnOpenModal(
				{
					sId: "QListPrintBox",
					sTitle: "Печать",
					sContent: sContent,
					oButtons:
					{
						"Печать" :
						{
							sClass:"btn-primary",
							fnOnClick: function($btn, $Modal)
							{
								// Если в настоящий момент мы уже печатаем, то надо отменить операцию.
								if($Modal.data("printing")) return false;
								// Если нет, то продолжаем…

								$Modal.data("printing", 1);

								var $form = $("#printingSettingsForm");

								if($(this).is(".disabled")) return false;

								var sSource = oTbl.data("qDataTable").aOptions["sHtmlExportUrl"];
								var oSDT = oTbl.api().settings()[0].oInit;
								var aoData = oTbl._fnAjaxParameters(oSDT);

								//console.log("aoData: %o", aoData);

								//Но надо еще прогнать через функцию, которая добавит нам фильтры и пр.
								var arr = Q.dataTables.fnPreQuery(oTbl, sSource, aoData, null);

								//console.log("arr: %o", arr);

								sSource = arr.sSource;
								aoData = arr.aoData;

								for(var i=0, len = aoData.length; i < len; i++)
								{
									$form.append($("<input type=\"hidden\"/>").attr(aoData[i]));
								}

								if(aIds.length >= 1)
								{
									if(!sSource.split("?").length) sSource += "?";
									else sSource += "&";
									sSource += "ids="+aIds.join(",");
								}

								/****
								if(!sSource.split("?").length) sSource += "?";
								else sSource += "&";
								sSource += $form.serialize()
								***/

//								console.log("sSource: ", sSource);

								$btn.data("loading-text","Загружаю…").buttonStartLoading();

								var win = window.open('', '_blank');
								win.document.write('Идёт загрузка…');
								$.post(sSource, $form.serializeArray(), function (data)
								{
								    $btn.buttonStopLoading();
								    $Modal.data("printing", 0);
								    win.document.open();
								    win.document.write(data);
								    win.document.close();

								});

								//var w = window.open(sSource);
								//w.print();

								return false;

//								$("#printingSettingsForm")
							}
						},
						"Отмена" :
						{
							fnOnClick: function($btn, $Modal)
							{
								$Modal.data("printing", 0);
							}
						}
					},
					fnOnOpen: function($Modal)
					{
						$("#printingTitle").val(oTbl.data("qDataTable").aOptions.sListTitle);

						var $buttons = $Modal.find("div.ColumnsSelectorButtons");
						var $btnAll = $buttons.children(".ColumnsSelectAll");
						var $btnNone = $buttons.children(".ColumnsSelectNone");
						var $btnRestore = $buttons.children(".ColumnsSelectionRestore");

						var $aInputs = $Modal.find("input.columnToggler");
						$btnAll.click(function()
						{
							$aInputs.attr("checked", "checked");
						});
						$btnNone.click(function()
						{
							$aInputs.attr("checked", 0).removeAttr("checked");
						});
						$btnRestore.click(function()
						{
							$aInputs.each(function()
							{
								var $this = $(this);
								if($this.data("default"))
									$this.attr("checked", "checked");
								else
									$this.attr("checked", 0).removeAttr("checked");
							});
						});

					}
				});
			});

            if ( oThisQ.aOptions.bHasRss )
            {
                $place4btns.find(".exportGroup").append('<div class="btn btn-light form-control rss" style="margin-left:9px;">RSS</div>');
                var $rss = $place4btns.find("div.rss");
                $rss.click(function()
                {
                    var sSource     = oThisQ.aOptions.sRssUrl;
                    var aIds        = oTbl.data("qDataTable").fnGetSelected();
                    var oSDT        = oTbl.api().settings()[0].oInit;
                    var aoData      = oTbl._fnAjaxParameters(oSDT);
                    var arr = Q.dataTables.fnPreQuery(oTbl, sSource, aoData, null);
                    sSource = arr.sSource;
                    aoData = arr.aoData;
                    if ( aIds.length>0 )
                        sSource += "ids="+aIds.join(",");
                    for(var i=0, len = aoData.length; i < len; i++)
                    {
                        var name = new String(aoData[i].name);
                        var value = new String(aoData[i].value);
                        if ( name.match(/^filters/ig) )
                        {
                            //вариант1
                            sSource += "&"+name+"="+value;
                        }
                    }
                    var token = oThisQ.aOptions.aaUserTokens[oThisQ.aOptions.sEntity].rss;

                    sSource+="&token="+token
                    //console.log(sSource);
                    //location.href = sSource;
                    window.open( sSource, '_blank' );
                });
            }

			//console.dir(oThisQ);
			if(oThisQ.aOptions.bHasReports)
			{
				//console.dir("!!");
				$place4btns.append('<button id="'+oThisQ.aOptions.sDomIdPrefix+'ReportsBtn" class="btn btn-primary" style="margin-left: 9px;">'+oThisQ.aOptions.sReportsButtonCaption+'</button>');
				oThisQ.$.btnReports = $("#"+oThisQ.aOptions.sDomIdPrefix+"ReportsBtn")
					.unbind('click')
					.click(function()
					{
						var aIds = oThisQ.fnGetSelected();

						Q.fnOpenModal(
						{
							sTitle: "Отчёты",
							sId:oThisQ.sDomId+'ReportsDialog',
							sUrl:oThisQ.aOptions.sReportsUrl,
							oParams: {id:aIds, params:oThisQ.aOptions.aReportsParams?oThisQ.aOptions.aReportsParams:[]},
							iWidth:1024
						});

						return false;
					});
			}

			// Графики
			var that = this;
			if(oThisQ.aOptions.sChartsUrl.length > 1)
			{
				$place4btns.append('<button id="'+oThisQ.aOptions.sDomIdPrefix+'ChartsBtn" class="btn btn-light form-control" style="margin-left: 9px;"><i class="icon-charts"></i></button>');
				oThisQ.$.btnCharts = $("#"+oThisQ.aOptions.sDomIdPrefix+"ChartsBtn")
					.unbind('click')
					.click(function()
					{
						var aIds = oThisQ.fnGetSelected();
						var ids = aIds; // нет времени объяснять.

						// _TODO: DRY! Этот кусок кода уже использовался там, где обрабатывается кнопка в списке. Вынести в функцию. СРОЧНО
						var oOtherPostVars = {};
						if(1) // $this.data("sendfilters")) // _TODO: Сделать настройку!
						{
							oOtherPostVars.filters = {};

							// #FIXME @todo DRY!!!!
							$("#"+oThisQ.aOptions.sDomIdPrefix+"Filters").find("div.q-filter").each(function()
							{
								var $filter = $(this);
								$filter.find("input, select, textarea").each(function()
								{
							        if(this.name) // только те, у которых есть имя =)
						        	{
						        		var $this = $(this);
						        		if(this.type=="checkbox" || this.type=="radio") if(!$this.is(":checked")) return;
						        		var sVal = $this.val();
						        		var sName = this.name.split(/^filter_/).join("");
						        		// _NB: Здесь отличие от исходного кода!!! (из кнопки) _TODO: Перенести!!
						        		if(sName.match(/\[\]$/))
						        		{
						        			var aName = sName.split("[]");
						        			sName = aName[0];
						        			// _TODO: сделать для многомерных массивов
						        			if(oOtherPostVars.filters[sName] === undefined)
						        				oOtherPostVars.filters[sName] = [];

						        			oOtherPostVars.filters[sName].push(sVal);
						        		}
						        		else
						        		{
						        			oOtherPostVars.filters[sName] = sVal;
						        		}
						        	}
							    });
							});
						}

						if(1) // $this.data("sendrow") && ids.length) // _TODO: Сделать настройку!
						{
							oOtherPostVars.row = {};
							//console.log(ids.length);
							for(var i=0; i<ids.length; i++)
							{
								var id = ids[i];
								//console.log("atatata: "+i);
								if(!i)
								{
									oOtherPostVars.row = new cloneObject(that.ooData[id]);
								}
								else
								{
									for( var sKey in that.ooData[id] )
									{
										//console.log("sKey="+sKey+";  oOtherPostVars.row[sKey]="+oOtherPostVars.row[sKey]+"; that.ooData[id][sKey]="+that.ooData[id][sKey]);
										if(oOtherPostVars.row[sKey] != that.ooData[id][sKey])
											oOtherPostVars.row[sKey] = ':null:';
									}
								}
							}
						}



						Q.fnOpenModal(
						{
							sTitle: "График",
							sId:oThisQ.sDomId+'ChartsDialog',
							sUrl:oThisQ.aOptions.sChartsUrl,
							oParams: $.extend({}, oOtherPostVars, { external_ids: aIds }),
							iWidth: 720
						});
						return false;
					});
			}

			// Календарь
			if(oThisQ.aOptions.sCalendarUrl.length > 1)
			{
				$place4btns.append('<button id="'+oThisQ.aOptions.sDomIdPrefix+'CalendarBtn" class="btn btn-light form-control" style="margin-left: 9px;"><i class="icon-calendar"></i></button>');
				oThisQ.$.btnCalendar = $("#"+oThisQ.aOptions.sDomIdPrefix+"CalendarBtn")
					.unbind('click')
					.click(function()
					{
						Q.fnOpenModal(
						{
							sTitle: "Календарь",
							sId:oThisQ.sDomId+'CalendarDialog',
							sUrl: oThisQ.aOptions.sCalendarUrl,
							iWidth:960//,
							//iMaxHeight: 720
						});
						return false;
					});
			}

			// Импорт
			if(oThisQ.aOptions.sImportUpload.length > 1)
			{
				$place4btns.append('<button id="'+oThisQ.aOptions.sDomIdPrefix+'ImportBtn" class="btn btn-light form-control" style="margin-left: 9px;"><i class="icon-file-import"></i><span class="hide-in-embeded"> Импорт из Excel</span></button>');
				oThisQ.$.btnImport = $("#"+oThisQ.aOptions.sDomIdPrefix+"ImportBtn")
					.unbind('click')
					.click(function()
					{
						Q.fnOpenModal(
						{
							sTitle: "Импорт",
							sId:oThisQ.sDomId+'ImportDialog',
							sUrl: oThisQ.aOptions.sImportUpload,
							iWidth:1024
						});
						return false;
					});
			}

			//Размер шрифта
			if(oTbl.data("qDataTable").aOptions.aFeatures.bShowFontSettings)
			{

			$place4btns.append('<div class="btn-group zoomGroup" id="'+oThisQ.aOptions.sDomIdPrefix+'zoomGroup"><div id="'+oThisQ.aOptions.sDomIdPrefix+'zoomOut" data-zoom-change="-1" class="btn btn-light form-control zoomOut" style="margin-left: 9px; padding-top:9px;">А</div><div id="'+oThisQ.aOptions.sDomIdPrefix+'zoomIn" data-zoom-change="1" class="btn btn-light form-control zoomIn"></i>A</div></div></div>');

			var iZoom = localStorage.getItem('QSettings/'+oThisQ.aOptions.sDomIdPrefix+'CurrentListZoom');
			var sClassZoom = '';
			iZoom = Number(iZoom, 10);

			if(!iZoom) iZoom = 0;

			if(iZoom < 0)
				sClassZoom = 'listZoomOut'+iZoom;
			else if(iZoom > 0)
				sClassZoom = 'listZoomIn-'+iZoom;
			else sClassZoom = 'listZoom-0';

			this.$dataTablesWrapper.find('div.dataTables_scroll').addClass(sClassZoom);
			// // oThisQ.oTable.fnAdjustColumnSizing(false);
			oThisQ.fnAutoSize();

			localStorage.setItem( 'QSettings/'+oThisQ.aOptions.sDomIdPrefix+'CurrentListZoom', iZoom);

			oThisQ.$.btnZoomOut = $("#"+oThisQ.aOptions.sDomIdPrefix+"zoomOut");
			oThisQ.$.btnZoomIn = $("#"+oThisQ.aOptions.sDomIdPrefix+"zoomIn");

			oThisQ.$.btnZoomOut.attr("title","Уменьшить размер отображаемого шрифта в списке").tooltip({"placement":"top", delay:{show:800, hide:50}});
			oThisQ.$.btnZoomIn.attr("title","Увеличить размер отображаемого шрифта в списке").tooltip({"placement":"top", delay:{show:800, hide:50}});

			oThisQ.$.btnGroupZoom = $("#"+oThisQ.aOptions.sDomIdPrefix+"zoomGroup").on('click', '.btn', $.proxy(function(e)
			{
				// e.target
				var $btn = $(e.currentTarget); // e.currentTarget
				var $dataTable = $(this.$dataTablesWrapper).find('div.dataTables_scroll');

				var iZoomChange = $btn.data('zoom-change');
				iZoomChange = Number(iZoomChange);

				var iCurrentZoom = localStorage.getItem('QSettings/'+oThisQ.aOptions.sDomIdPrefix+'CurrentListZoom');
				var sClassCurrentZoom = 'listZoom-0';
				iCurrentZoom = Number(iCurrentZoom, 10);

				if(iCurrentZoom < 0)
					sClassCurrentZoom = 'listZoomOut'+iCurrentZoom;
				else if(iCurrentZoom > 0)
					sClassCurrentZoom = 'listZoomIn-'+iCurrentZoom;

				iCurrentZoom += iZoomChange;
				if(iCurrentZoom < -5) iCurrentZoom = -5;
				if(iCurrentZoom > 5) iCurrentZoom = 5;

				var sClassChangeZoom = '';

				if(iCurrentZoom < 0)
					sClassChangeZoom = 'listZoomOut'+iCurrentZoom;
				else if(iCurrentZoom > 0)
					sClassChangeZoom = 'listZoomIn-'+iCurrentZoom;
				else sClassChangeZoom = 'listZoom-0';


				$dataTable.removeClass(sClassCurrentZoom);
				$dataTable.addClass(sClassChangeZoom);

				localStorage.setItem('QSettings/'+oThisQ.aOptions.sDomIdPrefix+'CurrentListZoom', iCurrentZoom);

				oThisQ.fnAutoSize();
			}, this));

			};

			inputPlaceholder($inputSearch.get(0), "#999");

			//Сделаем tooltip-подскази к кнопкам
			this.$dataTablesWrapper.find("button.ColVis_Button").attr("title","Выбрать, какие колонки показывать в списке.").tooltip({"placement":"right", delay:{show:800, hide:50}});
			oTbl.data("qDataTable").$.btnRefresh.attr("title","Обновить список.").tooltip({"placement":"top", delay:{show:800, hide:50}});
			if(oTbl.data("qDataTable").aOptions.aFeatures.bAllowExcel) {
				$exportToCsvButton.attr("title","Экспортировать в Excel.").tooltip({"placement":"top", delay:{show:800, hide:50}});
				$printButton.attr("title","Сгенерировать страницу в формате, подходящем для печати или вставки в Word.").tooltip({"placement":"top", delay:{show:800, hide:50}});
			}
			if(oThisQ.$.btnReports) oThisQ.$.btnReports.attr("title","Подготовить отчёт или сформировать печатную форму.").tooltip({"placement":"top", delay:{show:800, hide:50}});
			if(oThisQ.$.btnCalendar) oThisQ.$.btnCalendar.attr("title","Календарь событий.").tooltip({"placement":"top", delay:{show:800, hide:50}});
			if(oThisQ.$.btnCharts) oThisQ.$.btnCharts.attr("title","Аналитические графики и диаграммы.").tooltip({"placement":"top", delay:{show:800, hide:50}});
			if(oThisQ.$.btnImport) oThisQ.$.btnImport.attr("title","Загрузить данные из Excel или документа в формате csv. Подходит также для импорта из 1C.").tooltip({"placement":"top", delay:{show:800, hide:50}});

			// Спрячем кнопки прокрутки, если у нас стоит показывать все записи.
			if(oTbl.api().settings()[0].oInit.iDisplayLength == -1) this.$dataTablesWrapper.find("div.pagination").hide();



			// Инициализируем галочку «Выбрать все записи»
			this.data("qDataTable").$.DataTable_wrapper.find("thead input.select_all").click(function(e)
			{
				oThisQ.fnToggleRowSelection(oThisQ.$.DataTable_wrapper.find("tbody tr.odd, tbody tr.even"), $(this).prop('checked'));
				oThisQ.fnUpdateSelection();
				e.stopPropagation();
			});


		},
		"fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull )
		{
			var that = this;

			// if(nRow.bMyInitted) return; // чтобы избежать множественного вызова

			nRow.bMyInitted = true;

            //Раскрасим строки
			//alert(aData.mQColorCol);
            if ( aData.mQColorCol !== undefined)
            {
				switch(Number(aData.mQColorCol))
				{
					case 2:
						$(nRow).addClass("green");
						break;
					case 1:
						$(nRow).addClass("yellow");
						break;
					case -1:
						$(nRow).addClass("red");
						break;
					case 5:
						$(nRow).addClass("blue");
						break;
					case 9:
						$(nRow).addClass("gray");
						break;
					case 10:
						$(nRow).addClass("purple");
						break;
				}
        	};

        	var aSelectedIds = that.data("qDataTable").fnGetSelected();
        	$(nRow).addClass("row-id-"+aData.mQFormId);
        	//alert("id:"+aData.mQFormId+"; aSelectedIds: ["+aSelectedIds+"]; is in array? - "+$.inArray(aData.mQFormId, aSelectedIds));
        	var bIsSelected = ($.inArray(aData.mQFormId, aSelectedIds) != -1);

        	// Добавляем чекбокс
            var $checkbox = $(`
                <div class="checkbox-custom checkbox-default">
                    <input type="checkbox" name="selected_ids[]">
                    <label></label>
                </div>`);

            $checkbox.find("input")
                   .val(aData.mQFormId)
                   .prop('checked', bIsSelected);

            $(nRow).find("td.checkbox").html($checkbox);

        	that.data("qDataTable").fnToggleRowSelection($(nRow), bIsSelected);

            $(nRow).find("td").not(".initted").each(function()
            {
            	Q.dataTables.fnColumnProccessor(this, that.api());
            });

            that.data("qDataTable").ooData[aData.mQFormId] = new cloneObject(aData);
            delete that.data("qDataTable").ooData[aData.mQFormId].mQFormId;


            return nRow;
        },
        "fnHeaderCallback": function(nHead, aData, iStart, iEnd, aiDisplay)
        {

        	var oTbl = this;

			$(nHead).closest("table.dataTable").addClass("initted")
			.find("th").tooltip({placement:"top"});
			$("body div.tooltip").remove(); // Хак, который уберет все открытые тултипы в случае, если нажать на сортировку колонки с тултипом и не убрать мышку.

        },
		"fnDrawCallback": function()
		{
			// this.data("qDataTable").$.DataTables_scrollHead.find("th.pre-hidden").removeClass("pre-hidden");
			var oTbl = this;
			if(!this.my_bIsDrawn) // Hack to prevent double fnDrawCallback call (this.my_bIsDrawn sets false in fnServerData)
			{
				// Обновим кружочки с количеством записей на вкладках (если это встроенный список)
				this.data("qDataTable").fnUpdateFormTabsCounts();

				var $scrollBody = $(this).parents("div.dataTables_scrollBody");
				if(this.my_iScrollTop == 99999) this.my_iScrollTop = $scrollBody[0].scrollHeight - $scrollBody.height();

				// Прокрутим до самого верха:
				$scrollBody.animate({scrollTop: this.my_iScrollTop}, 500);

				this.my_bIsDrawn = true; // Hack to prevent double fnDrawCallback call

				this.data("qDataTable").fnAutoSize(false);
				//console.log("fnDrawCallback");

				/**
				 * @field {object} oTbl Объект DataTables
				 * Будем использовать для получния доступа к объекту dataTables
				 * из jQuery callback'ов
				 */
				var oTbl = this;
				oTbl.data("qDataTable").fnUpdateSelection();

				/*
				 * Если таблица пуста, то выходим
				 */
				if ( ! oTbl.api().row(0).data() ) return;

				/*
				 * Открытие на просмотр по двойному клику
				 */
				 /***/
				if(oTbl.data("qDataTable").aOptions.bDblClickForm)
				{
					$(this).find("tr").not(".group-line").not(".dblclick-initted").addClass("dblclick-initted").dblclick(function(e)
					{
						var aData = oTbl.api().row(this).data();;
						var mQFormId = aData.mQFormId;

						oTbl.data("qDataTable").fnToggleRowSelection($(this), true);
						oTbl.data("qDataTable").fnUpdateSelection();

						//console.log("Double clicked!");

						oTbl.data("qDataTable").fnOpenView(mQFormId);
					});
				};



				/*
				 * Выделение строчек
				 * @todo: ПЕРЕНЕСТИ в fnInit !!!!
				 * (тогда и .off не нужен будет!)
				 */
				 //console.log("binding select event");
				$(this).off('mousedown.q_row_selection click.q_row_selection')
				.on('mousedown.q_row_selection', function(e)
				{
					if(e.shiftKey)
					{
						// For non-IE browsers
						e.preventDefault();
						// For IE
						if ($.browser.msie) {
							this.onselectstart = function () { return false; };
							var me = this; // capture in a closure
							window.setTimeout(function (){me.onselectstart = null;}, 0);
						}
					}
				})
				.on('click.q_row_selection', 'td.checkbox', function(e)
				{
					if( !(e.ctrlKey || e.altKey || e.metaKey || e.shiftKey) )
					{
						var $row = $(e.currentTarget).closest("tr");
						oTbl.data("qDataTable").fnToggleRowSelection($row, !$row.is(".row_selected"));
						oTbl.data("qDataTable").fnUpdateSelection();
						$(oTbl).find("tr.last_selected").removeClass("last_selected");
						oTbl.data("qDataTable").fnToggleRowSelection($(this), true);
						$row.addClass("last_selected");
					}
					// если же зажаты функциональные клавиши, то обрабатываем галочку стандартно (ниже)

				})
				.on('click.q_row_selection', 'tr:not(.group-line):not(.child)', function(e)
				{
					//alert("!!");
					var $row = $(e.currentTarget);

					if(e.ctrlKey || e.altKey || e.metaKey)
					{
						if($row.is(".row_selected"))
						{
							oTbl.data("qDataTable").fnToggleRowSelection($(this), false);
						}
						else
						{
							$(oTbl).find("tr.last_selected").removeClass("last_selected");
							oTbl.data("qDataTable").fnToggleRowSelection($(this), true);
							$row.addClass("last_selected");
						}
					}
					else if(e.shiftKey)
					{
						//console.log("Shift+Click111");
						var a$trs = $row.parent().children().not(".group-line");
						var iClicked = a$trs.index($row);
						var iLastSelected = a$trs.index(a$trs.filter(".last_selected"));

						//console.log(iClicked, "-", iLastSelected);

						if(iLastSelected == -1) // Если ничего еще не выбирали.
						{
							oTbl.data("qDataTable").fnToggleRowSelection($(this), true);
							$row.addClass("last_selected");
						}
						else
						{

							if(iLastSelected < iClicked)
							{
								oTbl.data("qDataTable").fnToggleRowSelection(a$trs.slice(iLastSelected,iClicked+1), true);
							}
							else if(iLastSelected > iClicked)
							{
								oTbl.data("qDataTable").fnToggleRowSelection(a$trs.slice(iClicked, iLastSelected), true);
							}

							a$trs.filter(".last_selected").removeClass("last_selected");
							a$trs.eq(iLastSelected).addClass("last_selected");
						}
					}
					else
					{
						// Если не зажаты функциональные клавиши, то обрабатываем галочку стандартно (см. выше)
						if($(e.target).is("td.checkbox, td.checkbox input")) return;

						var a$RowsSelected = $(oTbl).find(".row_selected");
						if(a$RowsSelected.length > 1)
						{
							oTbl.data("qDataTable").fnToggleRowSelection(a$RowsSelected, false);
							a$RowsSelected.removeClass("last_selected");

							oTbl.data("qDataTable").fnToggleRowSelection($row, true);
							$row.addClass("last_selected");
						}
						else
						{
							var bToSelect = true;
							if($row.is(".row_selected"))
							{
								//console.log("i'm already selected");
								bToSelect = false;
							}

							oTbl.data("qDataTable").fnToggleRowSelection(a$RowsSelected, false);
							a$RowsSelected.removeClass("last_selected");

							if(bToSelect)
							{
								oTbl.data("qDataTable").fnToggleRowSelection($row, true);
								$row.addClass("last_selected");
							}
						}
					}

					oTbl.data("qDataTable").fnUpdateSelection();
				});
			}
				/*
				 * Grouping Rows
				 */

				var oData0 = oTbl.fnGetData(0);
				if(oData0 && oData0.mQGroupCol!== undefined)
				{

					var $trs = $(this).find('tbody tr');
					var iColspan = $trs.eq(0).find('td').length;//тут определим фактический колспан,опираясь на dom
					if(iColspan != 0) // хак, для того, чтобы нормально работала группировка (без добавления с colspan=0)
					{
						iColspan = oTbl.fnSettings().aoColumns.length;//тут определим максимальный колспан,чтобы при открытии колонок хватало ширины колспана
						var sLastGroup = "";
						if(oData0.mQSubGroupCol!== undefined) var sLastSubGroup = "";
						$trs.each(function()
						{
							var nTr = this;

							var aData = oTbl.api().row(this).data();
							if(aData)
							{
								var sGroup = aData.mQGroupCol;
								if(oData0.mQSubGroupCol!== undefined) var sSubGroup = aData.mQSubGroupCol;

								if ( sGroup != sLastGroup )
								{
									if(sGroup)
									{
										///alert("^^"+sGroup+"^^");
										var nGroup = document.createElement( 'tr' );
										var nCell = document.createElement( 'th' );
										nGroup.className = "group-line";
										nCell.colSpan = iColspan;
										nCell.className = "group";
										nCell.innerHTML = sGroup;
										nGroup.appendChild( nCell );
										nTr.parentNode.insertBefore( nGroup, nTr );
										sLastGroup = sGroup;
									}
									sLastSubGroup = null;
								}

								if(oData0.mQSubGroupCol!== undefined)
								{
									if(sSubGroup != sLastSubGroup)
									{
										if(sSubGroup)
										{
											var nGroup = document.createElement( 'tr' );
											var nCell = document.createElement( 'th' );
											nGroup.className = "subgroup-line";
											nCell.colSpan = iColspan;
											nCell.className = "subgroup";
											nCell.innerHTML = sSubGroup;
											nGroup.appendChild( nCell );
											nTr.parentNode.insertBefore( nGroup, nTr );
											sLastSubGroup = sSubGroup;
										}
									}
								}
							};

						} );
					}

				}

				var w = 0;// oTbl.data("qDataTable").$.DataTables_scrollBody.find("table.dataTable").innerWidth();
				//oTbl.data("qDataTable").$.DataTables_scrollHead.width(w).children().width(w).children().width(w);

				/***/
				var i = 0;
				var n;
				var nGroup;
					//alert(oTbl.data("qDataTable").$.DataTables_scrollBody.find("thead").html());

				// Чтобы у нас правильно пересчиталась ширина, сначала разрушаем таблицу…
				// oTbl.data("qDataTable").$.MainTbl.floatThead('destroy');

				var $bodyTable = oTbl.data("qDataTable").aOptions.sFrameAs ? oTbl.data("qDataTable").$.DataTables_scrollBody : oTbl.data("qDataTable").$.MainTbl;
				var $headTable = oTbl.data("qDataTable").aOptions.sFrameAs ? oTbl.data("qDataTable").$.DataTables_scrollHead : oTbl.data("qDataTable").$.MainTbl;

				$headTable.find("colgroup").remove();
				$bodyTable.find("colgroup").remove();

				/**
				$headTable.find("th").css({"width":"auto", "min-width":"none", "max-width":"none"});
				if(oTbl.data("qDataTable").aOptions.sFrameAs) // если же !sFrameAs, то у нас body и head— одна и та же таблица.
					$bodyTable.find("th").css("width", "auto");

				if(oTbl.data("qDataTable").aOptions.sFrameAs)
				{
					var aiGroupWidths = {};

					$headTable.find("th.th-primary").each(function()
					{
						i++;
						n = $(this).data("col-num");
						//alert(n);
						var wc = Number($(this).outerWidth());
						w += wc;
						//console.log("max-width:"+ wc+"px;");
						$headTable.find("th.th-"+n).css({"max-width":wc+"px","min-width":wc+"px","width":wc+"px"});

						nGroup = $(this).data("group-num")
						if(!empty(nGroup))
						{
							if(typeof(aiGroupWidths[nGroup])=='undefined') aiGroupWidths[nGroup] = 0;
							aiGroupWidths[nGroup] += wc;
						}
					});
					//console.log("aiGroupWidths: %o", aiGroupWidths);
					//console.log("aiGroupWidths.length: ", aiGroupWidths.length);
					for(var i in aiGroupWidths)
					{
		//				console.log('th.th-group-'+i);
						$headTable.find('th.th-group-'+i).css({"max-width":aiGroupWidths[i]+"px","min-width":aiGroupWidths[i]+"px","width":aiGroupWidths[i]+"px"})
					}
				}
				else
				{

					// var oFloatTheadGroups = oTbl.data("qDataTable").$.MainTbl.floatThead('getRowGroups');
					// oFloatTheadGroups.find('colgroup').remove();

					// var i = 0;
					// $bodyTable.css("table-layout", "auto");
					// $headTable.find("th").each(function()
					// {
					// 	var $td = $bodyTable.find("tbody tr:not(.group-line):eq(0) td:eq("+i+")");
					// 	var wc = $td.outerWidth();
					// 	$(this).find("th.th-"+iColIndex).css({"max-width":wc+"px","min-width":wc+"px","width":wc+"px"});
					// 	i++;
					// 	var iColIndex = oTbl.fnGetPosition( $td.get(0) )[2];
					// 	$headTable.find("th.th-"+iColIndex).css({"max-width":wc+"px","min-width":wc+"px","width":wc+"px"});
					// });
					// $bodyTable.css("table-layout", "fixed");
				}

				/**/
			if(!this.my_bIsDrawn) {
				oTbl.data("qDataTable").fnAutoSize();

			};


		},
		"void":null
	};

	/**
	 * Значения по умолчанию для маленькой таблицы dataTables
	 * @see Q.dataTables.oDefaultTableOptions
	 */
	Q.dataTables.oDefaultSmallTableOptions = {};
	$.extend
	(
		Q.dataTables.oDefaultSmallTableOptions,

		Q.dataTables.oDefaultTableOptions,

		{
			"sDom": '<r>t'
		}
	);
